<template>
    <div>

        <!-- Modal for add a lamp to a monitoring zone -->
        <AddToMonitoringZone :lamp="lampToAdd" v-model="modalAddToZone" :alerts="alerts" @hide="resetAddToZone"/>

        <nav-bar-main></nav-bar-main>

        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>


        <!-- <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div> -->
        <ErrorBanner />

        <Loader />

        <div v-if="plantDetails != null && unitsDetails != null" class="animated fadeIn container-fluid">

            <!-- alert per feedback dei comandi -->
            <b-row class="alert-feeback-command">
                <b-col lg="12" md="12">
                    <b-alert v-for="(alert, indexA) in alerts" :show="alert.timeLeft"
                        v-bind:key="indexA" :variant="alert.state" dismissible fade
                        @dismissed="alert.timeLeft = 0" @dismiss-count-down="alert.countDownChanged">
                        <div>
                            <i v-if="alert.state == 'danger'"
                                class="fa fa-1x fa-exclamation-circle mr-2"></i>
                            <i v-if="alert.state == 'success'"
                                class="fa fa-1x fa-check-circle mr-2"></i>
                            <div class="pb-3" style="display:inline; font-size:13px; height:15px;">
                                {{ alert.msg }}</div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col sm="12" md="2" offset-md="10">
                <b-input-group>
                  <b-form-input type="text" :placeholder="$t('planimetry.search_placeholder')" v-model="highlightedLamp"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="evidenzia()"><i class="fa fa-search"></i> </b-button>
                    </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <div class="filesystem-containers">
              <div class="d-flex mb-4 pb-4">
                <nav aria-label="breadcrumb" class="breadcrumb-nav-container">
                  <ol class="breadcrumb">
                    <draggable
                      v-if="openedFolderId"
                      :list="folders.find(f => f.id === 'root').ambientesIds"
                      group="filesystem"
                      ghost-class="hide-ghost"
                      tag="li"
                      class="breadcrumb-item home-drop-zone"
                      @add="saveFileSystem"
                    >
                      <a href="#" @click.prevent="goBack">
                        <i class="fa fa-home"></i> {{ $t("Home") }}
                      </a>
                    </draggable>

                    <li v-else class="breadcrumb-item active">
                      <i class="fa fa-home icon-gap"></i> {{ $t("Home") }}
                    </li>

                    <li v-if="openedFolderId" class="breadcrumb-item active ml-1">
                      <i class="fa fa-folder-open text-warning icon-gap"></i> {{ currentFolderName }}
                    </li>
                  </ol>
                </nav>
                <!-- menu-class="shadow-lg border-0" -->
                <b-dropdown
                  v-if="($store.getters.userRole === 'installer' || $store.getters.userRole === 'collab') && openedFolderId === null"
                  class="d-none d-md-block"
                  no-caret
                  right
                  variant="light"
                  toggle-class="custom-add-btn d-flex align-items-center px-3 py-2"
                  menu-class="custom-dropdown-menu"
                  aria-label="Add new item"
                >
                 <!-- class="typo-butt-add mt-3 mr-1" -->
                  <template #button-content>
                    <i class="fas fa fa-1x fa-plus mr-2"></i>
                    {{ $t("planimetry.add_element") }}
                  </template>
                  <!-- <b-dropdown-header>{{ $t("planimetry.add_element") }}</b-dropdown-header> -->
                  <b-dropdown-item @click="addFolder()">
                    {{ $t("navbar_dispositivi.new_folder") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalDisclaimer()">
                    {{ $t("navbar_dispositivi.new_"+ section) }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <b-row>
                <!-- se non siamo dentro ad una cartella, visualizziamo la Home con cartelle e mappe
                     si visualizzano le cartelle, che wrappiamo con un oggetto 'draggable' rispetto ad 'ambientesIds',
                     in modo da poter spostare le mappe, visualizzate sotto, dentro le cartelle -->
                <template v-if="openedFolderId === null">
                  <div class="row col-12">
                    <!-- xl="2" lg="3" md="4" sm="6" -->
                    <b-col
                      v-for="folder in displayFolders"
                      :key="folder.id"
                      cols="12" xl="4" lg="4" md="6" sm="6"
                      class="mb-4"
                    >
                      <draggable
                        group="filesystem"
                        :list="folder.ambientesIds"
                        ghost-class="hide-ghost"
                        sort="false"
                        @add="saveFileSystem"
                        filter=".no-drag"
                        prevent-on-filter="false"
                      >
                        <div class="folder-wrapper" @click="openFolder(folder.id)">
                          <div
                            v-if="folder.ambientesIds.length === 0"
                            class="card-header-actions"
                            style="position: absolute; top: 5px; right: 5px; z-index: 10;"
                          >
                            <b-link
                              class="text-danger"
                              @click.stop="removeFolder(folder.id)"
                            >
                              <i class="fa fa-times-circle"></i>
                            </b-link>
                          </div>
                          <div class="folder-visual">
                            <div class="folder-icon-container">
                              <i class="fa fa-folder fa-5x text-warning"></i>
                              <span class="item-count">{{ folder.ambientesIds.length }}</span>
                            </div>
                          </div>
                          <div class="folder-name-container text-center mt-2">
                            <div v-if="editingFolderId === folder.id">
                              <b-form-input
                                v-model="tempFolderName"
                                size="sm"
                                class="form-control-sm no-drag"
                                v-focus
                                @blur="saveRename(folder)"
                                @keyup.enter="saveRename(folder)"
                                @keyup.esc="editingFolderId = null"
                              />
                            </div>
                            <div v-else class="d-flex align-items-center justify-content-center">
                              <p class="mb-0 mr-2" @click="startRename(folder)">
                                {{ folder.name }}
                              </p>
                              <b-link class="text-muted small show-on-hover" @click.stop="startRename(folder)">
                                <i class="fa fa-edit"></i>
                              </b-link>
                            </div>
                          </div>
                        </div>
                      </draggable>
                    </b-col>
                  </div>
                </template>

                <draggable
                  class="row col-12"
                  group="filesystem"
                  v-model="currentlyVisibleCardIds"
                  ghost-class="hide-ghost"
                  drag-class="mini-drag-icon"
                  :force-fallback="true"
                  :fallback-tolerance="3"
                  @change="saveFileSystem"
                >
                <!-- xl="2" lg="3" md="4" sm="6" -->
                  <b-col
                    v-for="ambiente in visibleAmbientes"
                    :key="ambiente.id"
                    cols="12" xl="4" lg="4" md="6" sm="6"
                  >
                      <b-card border-variant="primary" body-class="nopad">
                        <div class="drag-content-only">
                          <i class="fa fa-file-image-o fa-2x"></i>
                          <span class="small d-block">{{ ambiente.name }}</span>
                        </div>

                        <div class="card-main-content">

                          <div class="custom-card-header d-flex justify-content-between align-items-center p-2 border-bottom bg-white">
                            <div class="text-truncate" style="max-width: 70%;">
                              {{ ambiente.name }}
                            </div>

                            <div class="card-header-actions">
                              <b-link
                                v-if="openedFolderId != null"
                                href="#"
                                class="text-folder-blue mr-3"
                                @click.stop="takebackHome(ambiente.id)"
                              >
                                <i class="fa fa-home"></i>
                              </b-link>
            <!-- class="text-danger" class="text-dark"-->
                              <b-link
                                href="#"
                                class="text-trash-black mr-2"
                                @click.stop="deleteAmbient(ambiente.id)"
                              >
                                <i class="fa fa-trash"></i>
                              </b-link>
                            </div>
                          </div>
                          <div class="p-2"></div>

                          <div
                            class="imgDiv"
                            :id="'imgDiv-' + ambiente.id"
                            style="position: relative; display: inline-block; "
                          >
                            <img
                              v-for="(lampInfo) in ambiente.lamps"
                              :tipo="lampInfo.tipo"
                              :id="'ambdot-' + ambiente.id + '-' + lampInfo.id + picLoaded['pic'+ambiente.id]"
                              :key="'linfo-' + ambiente.id + '-' + lampInfo.id + '-' + picLoaded['pic'+ambiente.id]"
                              :src="'/img/dot_' + lampInfo.status + '_' + lampInfo.tipo +'.png'"
                              :class="{'dotImg':true, 'dotImgEmergency': lampInfo.emergency=='on', 'dotImgHighlight': lampInfo.id == highlightedLamp.toUpperCase()}"
                              :style="{
                                left: lampInfo.px + '%',
                                top: lampInfo.py + '%',
                                position: 'absolute',
                                transform: 'translate(-50%, -50%)', /* This centers the dot on the point */
                              }"
                            />
                            <b-img
                              :id = "'imgDiv-' + ambiente.id"
                              :src="imageUrl(ambiente.id)"
                              style="display: block; width: 100%; height: auto;"
                              @click="apriModalById(ambiente.id)"
                              @load="picReady(ambiente.id)"
                            />
                            <div v-if="$store.getters.isProExpired" style="background-color: rgba(0,0,0,0.8); position:absolute; top: 0px; left:0px; right:0px; bottom: 0px" ></div>
                          </div>
                        </div>

                      </b-card>
                    <!-- </div> -->
                  </b-col>
                </draggable>

      <!-- Button per aggiungere una mappa o un folder SOLO MOBILE -->
       <!-- realizziamo un FAB, Floating Action Button -->
                <b-dropdown
                  v-if="($store.getters.userRole === 'installer' || $store.getters.userRole === 'collab') && openedFolderId === null"
                  class="square-dropdown d-md-none"
                  no-caret
                  variant="action-vibrant"
                  toggle-class="square-dropdown-toggle custom-fab"
                  aria-label="Add new item"
                  dropup
                >
                  <template #button-content>
                    <div class="plus">+</div>
                     <!-- d-none d-md-block -->
                    <div class="label">
                      {{ $t("navbar_dispositivi.add")}}
                    </div>
                  </template>
                  <b-dropdown-item @click="addFolder()">
                    {{ $t("navbar_dispositivi.new_folder") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalDisclaimer()">
                    {{ $t("navbar_dispositivi.new_"+ section) }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>

            </div>

          </div>

    <!-- Modal di visualizzazione mappa -->
        <b-modal v-if="currentAmbiente != null && currentAmbiente.name != null"
            id="modal-ambiente"
            :title="'Dettaglio ' + currentAmbiente.name"
            modal-class="modal-fullscreen"
            :hide-footer="true"
            @show="apertoDettaglioMappa"
            no-close-on-backdrop
            no-close-on-esc>

            <template v-slot:modal-header="{ close }">
                <b-row class="ModalPlanimetrieHeader">
                    <b-col cols="auto"><h5>{{$t('config_cu_modal.details')}}</h5></b-col>
                    <b-col lg="7" md="6" class="p-1">
                        <span v-if="updatingName">{{currentAmbiente.name}}</span>
                        <b-form-input v-if="!updatingName" v-model="currentAmbiente.name" :placeholder="$t('scenario.set_name')"></b-form-input>
                    </b-col>
                    <b-col lg="4" md="5" class="p-1">
                        <b-button @click="salvaDettaglioMappa($event)" variant="light" class="mr-1">
                            <span class="typo-label" :content="$t('planimetry.save')" v-tippy="{ placement : 'bottom',  arrow: true}">
                                <i class="fa fa-save" style="color:#0090CD"></i>
                            </span>
                        </b-button>
                        <b-button @click="generaPdfMappa()" variant="light" class="mr-1">
                            <span class="typo-label" :content="$t('planimetry.download')" v-tippy="{ placement : 'bottom',  arrow: true}">
                                <i class="fa fa-download" style="color:#0090CD"></i>
                            </span>
                        </b-button>
                        <b-button v-if="currentAmbiente.lamps.length == 0" @click="importaLampade()" variant="light">
                            <span class="typo-label" :content="$t('planimetry.import_lamps')" v-tippy="{ placement : 'bottom',  arrow: true}">
                                <i class="fa fa-file-import" style="color:#0090CD"></i>
                            </span>
                        </b-button>
                        <!-- modal di selezione della mappa da cui importare le lampade -->
                        <b-modal
                            id="selection-modal"
                            :title="$t('planimetry.select_map')"
                            @ok="importaLampadeFromSelectedMap()"
                            @hidden="selectedMapToImport = null"
                        >
                            <b-form-select v-model="selectedMapToImport">
                                <b-form-select-option :value="null" disabled>{{ $t('planimetry.select_an_option') }}</b-form-select-option>
                                <b-form-select-option
                                    v-for="(ambiente,index) in ambienti"
                                    v-if="ambiente.name !== currentAmbiente.name"
                                    :value="ambiente.id"
                                    :key="'amb-'+index"> {{ ambiente.name }}</b-form-select-option>
                            </b-form-select>
                        </b-modal>
                    </b-col>
                    <b-col cols="1" class="float-right p-1">
                        <button class="close close-x" @click="chiudiDettaglioMappa">x</button>
                    </b-col>
                </b-row>
            </template>

           <!-- <b-container> -->
            <div class="w-100" style="height: calc(100vh - 100px);">
                <b-row style="height:100%;">
                    <b-col sm="6" md="7" lg="8" class="h-100">
                      <div
                        class="imgDiv"
                        :id="'imgDivBig'"
                        style="border:2px solid black; overflow: hidden; background-color: white; display: flex; align-items: center; justify-content: center; "
                        @mousemove="mmove($event)"
                        @mouseup="mup($event)"
                      >
                        <panZoom
                            id="zoomContainer"
                            ref="zoomContainer"
                            @transform="zooming"
                            :options="{
                              minZoom: 0.2,
                              maxZoom: 10,
                              bounds: true,
                              boundsPadding: 0.1,
                              autocenter: true,
                            }"
                            style="overflow: hidden"
                        >
                        <!--  display: block; padding: 15px; -->
                          <div style="position: relative; display: inline-block; width: 100%; ">
                            <!-- fluid -->
                            <b-img
                                id="imgBig"
                                ref="imgBig"
                                :src="imageUrl(currentAmbiente.id)"
                                draggable = "false"
                                @load="bigImgLoaded"
                                @drop="dropLamp(null,-1,$event)"
                                @dragover.prevent
                                style="display: block; width: 100%"

                            />

                            <img v-for="(lampInfo,index) in currentAmbiente.lamps"
                              :key="'linfo2Big-' + currentAmbiente.id + '-' + lampInfo.id + imgLoaded"
                              draggable = "false"
                              :id="'dot' + lampInfo.id"
                              :ref="'dot' + lampInfo.id"
                              :src="'/img/dot_' + lampInfo.status + '_' + lampInfo.tipo + '.png'"
                              :class="[{dotSel: lampInfo.selected, dotImgBigEmergency: lampInfo.emergency=='on'},'dotImgBig']"
                              :style="{
                                position: 'absolute',
                                left: lampInfo.px + '%',
                                top: lampInfo.py + '%',
                                //transform: 'translate(-50%, -50%)' /* This centers the dot on the point */
                              }"
                              @mousedown="mdown(lampInfo, index, $event)"
                            />

                            <img id="dragged" src="/img/dot_blu.png" class="dotImgBig dotSel" style="visibility: hidden" />
                          </div>

                        </panZoom>

                        <transition name="fade">
                            <button
                                v-if="showReset"
                                @click="resetZoomToZero"
                                class="btn-reset-floating"
                                :title="$t('mains_logs.reset_zoom')"
                            >
                                <i class="fas fa-undo"></i> {{ $t('mains_logs.reset_zoom') }}
                            </button>
                        </transition>
                        <span class="infoTip" :content="$t('planimetry.info')" v-tippy="{ placement : 'top',  arrow: true}">
                            <i class="fa fa-2x fa-info-circle ml-3 mt-2" style="color:gold" ></i>
                        </span>
                        <div id="dropzoneContainer" v-if="showDropZone">
                            <b-button variant="danger" class="closeButton" @click="closeDropZone"><i class="fa fa-window-close"></i></b-button>
                            <vue-dropzone v-if="showDropZone"  ref="myVueDropzone" id="dropzone" :options="dropZoneOptions" v-on:vdropzone-file-added="fileAdded" v-on:vdropzone-sending="sendingImage" ></vue-dropzone>
                        </div>

                        <button
                          @click="showMinimap = !showMinimap"
                          class="btn-minimap-floating"
                          :title="showMinimap ? $t('planimetry.hide_minimap') : $t('planimetry.show_minimap')"
                        >
                          <i class="fas fa-th-large"></i> {{ showMinimap ? $t('planimetry.hide_minimap') : $t('planimetry.show_minimap') }}
                        </button>
                  <!-- minimap -->
                        <div v-if="showMinimap" class="minimap-container">
                          <img :src="imageUrl(currentAmbiente.id)" class="minimap-bg" />

                          <div class="minimap-viewfinder" :style="viewfinderStyle"></div>

                          <div v-for="lamp in currentAmbiente.lamps"
                            :key="'mini-' + lamp.id"
                            class="minimap-dot"
                            :style="{
                              left: lamp.px + '%',
                              top: lamp.py + '%',
                              transform: 'traslate(-50%, -505)'
                            }"
                            :class="'status-' + lamp.status">
                          </div>
                        </div>
                      </div>

                    </b-col>
                    <b-col sm="6" md="5" lg="4" class="lampList" >
                        <b-tabs v-model="tabIndex" class="PlanimetrieTabs">

                            <!-- Info dispositivo -->
                             <b-tab :title="$t('planimetry.tab_info')" lazy @click="resetFilterOnTabChange()">
                                 <div v-if="selectedLampDetails == null">
                                     <p>{{$t('planimetry.select_dot')}}</p>
                                 </div>
                                 <b-container fluid v-else >
                                     <b-row>
                                         <b-col class="subtitle">
                                             <p v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">{{ $t("emergency_device") }}</p>
                                             <p v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">{{ $t("lighting_device") }}</p>
                                             <p v-if="selectedLampDetails.device_function=='ALTRO'">{{ $t("other_device") }}</p>
                                             <p v-if="selectedLampDetails.device_function=='CU'">{{ $t("central_unit") }}</p>

                                             <!--- VISUALIZZAZIONE ANAGRAFICA LAMPADA -->
                                             <div v-if="selectedLampDetails.device_function!='CU'">
                                                <h5 v-if="!selectedLampDetails.product_desc.includes('Unknown')">{{selectedLampDetails.product_desc}}</h5>
                                                <h5 v-else>--</h5>
                                                <h5><b> ID: {{selectedLampDetails.id}}</b></h5>
                                                <h6 v-if="!selectedLampDetails.product_code.includes('NT')">cod: {{selectedLampDetails.product_code}}</h6>
                                                <h5 v-else>cod: --</h5>
                                              </div>

                                             <!--- VISUALIZZAZIONE ANAGRAFICA CENTRALE -->
                                             <div v-if="selectedLampDetails.device_function=='CU'">
                                                <h5>{{selectedLampDetails.cu_product_desc}}</h5>
                                                <h5><b> ID: {{selectedLampDetails.cu_id}}</b></h5>
                                                <div v-if="selectedLampDetails.cu_connected==true"> <i class="fa fa-2x fa-circle green"/> <span>{{ this.$t('connessa').toUpperCase() }}</span></div>
                                                <div v-if="selectedLampDetails.cu_connected==false"> <i class="fa fa-2x fa-circle gray" /> <span>{{ this.$t('disconnessa').toUpperCase() }}</span></div>
                                             </div>

                                             <!--- LAMPADE ORFANE -->
                                             <div v-if="hasOrphan(selectedLampDetails)">
                                               <div class="d-flex" v-if='selectedLampDetails.nodo_orfano==true'><i class="fa fa-2x fa-circle mr-2" style="color:violet"></i><span class="pt-1 typo-label">{{ $t("details_lamp.lamp_orphan_error") }}</span></div>
                                             </div>

                                             <!--- LAMPADE IN EMERGENZA -->
                                             <div v-if='selectedLampDetails.emer_active=="EMERGENZA IN CORSO"'>
                                                    <b-iconstack font-scale="1.8" class="mr-2">
                                                      <b-icon stacked icon="plug" style="color: orange;" scale="1"></b-icon>
                                                      <b-icon stacked icon="lightning-fill"  scale="0.5" style="color: white;"></b-icon>
                                                      <b-icon stacked icon="circle"  scale="1" style="color: orange ;"></b-icon>
                                                   </b-iconstack>
                                                   <span class="pt-1 typo-label">{{ $t("details_lamp.lamp_emergency_running") }}</span>
                                              </div>

                                              <!--- ERRORI COMMUNICAION LAMPADE -->
                                             <div v-if="hasErrorCom(selectedLampDetails)">
                                                <div class="d-flex" v-if='selectedLampDetails.error_com=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:#FFDE59"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_com")}}</span></div>
                                             </div>

                                             <!--- ERRORI LAMPADE -->
                                             <div v-if="hasError(selectedLampDetails)">
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_short=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_test=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_test")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_test_auto && selectedLampDetails.error_batt_test_auto=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_test_auto")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_ric_incompleta && selectedLampDetails.error_ric_incompleta=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_ric_incompleta")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_tubo_UV && selectedLampDetails.error_tubo_UV=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_tubo_UV")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_hardware=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_hardware")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led")}}</span></div>

                                                 <!-- Emergenza sicuro -->
                                                 <div class="d-flex" v-if='selectedLampDetails.error_com_ak_lamp == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_com_ak_lamp")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_com == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_com")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_hardware == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_hardware")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_lamp == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_lamp")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_id_duplicate == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_duplicate")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_full_short == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_full_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_open == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_open")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_partial_short == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_partial_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_low_voltage == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_low_voltage")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_polarity_reverse == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_reverse_polarity")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_lamp_programming == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_programming")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_under_threshold == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_under_threshold")}}</span></div>

                                                 <!-- errori su lampade di illuminazione -->
                                                 <div class="d-flex" v-if='selectedLampDetails.error_overpower=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_overpower")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_overvoltage=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_overvoltage")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_underpower=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_underpower")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_undervoltage=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_undervoltage")}}</span></div>

                                                 <!-- errori su lampade di illuminazione bluetooth -->
                                                 <div class="d-flex" v-if='selectedLampDetails.lampFail=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_fail")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.errorBallastCom=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_ballast_com")}}</span></div>

                                             </div>

                                            <!--- LAMPADE OK -->
                                            <div v-if="!hasOrphan(selectedLampDetails) && !hasError(selectedLampDetails) && !hasErrorCom(selectedLampDetails)">
                                                <div class="d-flex"><i class="fa fa-2x fa-circle mr-2" style="color:green"></i><span class="pt-1 typo-label">{{stateDesc(selectedLampDetails)}}</span></div>
                                            </div>


                                            <!--- ERRORI CENTRALE -->
                                            <div v-if="selectedLampDetails.device_function=='CU'">

                                            </div>


                                         </b-col>
                                         <b-col v-if="selectedLampDetails.device_function=='CU'" cols="3" class="text-right" >
                                            <img v-if="selectedLampDetails.cu_product_image" :src="this.pathDeviceImages + selectedLampDetails.cu_product_image" style="width:100%; height: auto" />
                                            <img v-if="!selectedLampDetails.cu_product_image && selectedLampDetails.cu_type=='sicuro'" :src="this.pathDeviceImages + 'cu_sicuro.jpg'" style="width:100%; height: auto" />
                                        </b-col>
                                         <b-col v-else cols="3" class="text-right" >
                                             <img v-if="selectedLampDetails.product_image" :src="this.pathDeviceImages + selectedLampDetails.product_image" style="width:100%; height: auto" />
                                             <img v-if="!selectedLampDetails.product_image && selectedLampDetails.device_function=='ILLUMINAZIONE'" :src="this.pathDeviceImages + 'luminary.jpg'" style="height:100px;" />
                                             <img v-if="!selectedLampDetails.product_image && selectedLampDetails.device_function!='ILLUMINAZIONE'" :src="this.pathDeviceImages + 'emergency.jpg'" style="height:100px;" />
                                         </b-col>
                                     </b-row>
                                     <b-row class="mt-4">
                                         <b-col cols="12">
                                            <!-- button di aggiungi a zona di monitoraggio -->
                                            <b-button v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'" variant="primary" class="mr-3 mb-2" @click="showAddToMonitoringZone(selectedLampDetails)">
                                                {{$t("add_to_monitoring_zone.button_add_to_zone")}}
                                            </b-button>
                                         <table class="table tabInfoPlanimetrie">
                                             <tr>
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_desc")}}</td>
                                                 <td class="descCol">{{selectedLampDetails.desc}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isBluetooth">
                                                 <td class="labCol">{{this.$t("zone.label_zone_name")}}</td>
                                                 <td>{{selectedLampDetails.zoneName}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isCentralized  && selectedLampDetails.device_function!='CU'">
                                                 <td class="labCol">{{this.$t("central_unit")}}</td>
                                                 <td>{{selectedLampDetails.cu_type.toUpperCase() + ' ' + selectedLampDetails.cu_id.split('#')[1]}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isCentralized && selectedLampDetails.device_function!='CU'">
                                                 <td class="labCol">{{this.$t("report_pdf.centrale_desc")}}</td>
                                                 <!-- <td>{{selectedLampDetails.cu_details.cu_desc}}</td> -->
                                                <td>{{selectedLampDetails.cu_desc}}</td>
                                             </tr>
                                             <tr>
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_order_code")}}</td>
                                                 <td v-if="selectedLampDetails.device_function=='CU'">{{selectedLampDetails.cu_order_code}}</td>
                                                 <td v-else>{{selectedLampDetails.order_code}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_type")}}</td>
                                                 <td>{{selectedLampDetails.lamp_type}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_actual_power")}}</td>
                                                 <td>{{(parseFloat(selectedLampDetails.potenza_attuale).toFixed(1) + " W")}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_energy")}}</td>
                                                 <td>{{((parseFloat(selectedLampDetails.energia_consumata)/1000).toFixed(1) + " kWh")}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_timeon")}}</td>
                                                 <td>{{(parseFloat(selectedLampDetails.TimeOn)).toFixed(0)  }}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_battery_state")}}</td>
                                                 <td>{{$t("param_lamp."+selectedLampDetails.battery_state)}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                <td class="labCol">{{this.$t("details_lamp.battery_desc")}}</td>
                                                <td>{{selectedLampDetails.battery_desc}}</td>
                                            </tr>
                                            <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                <td class="labCol">{{this.$t("details_lamp.battery_code")}}</td>
                                                <td>{{selectedLampDetails.battery_code}}</td>
                                            </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_parity")}}</td>
                                                 <td>{{$t("param_lamp."+selectedLampDetails.parity)}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_test_duration")}}</td>
                                                 <td>{{selectedLampDetails.test_duration}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_autonomy")}}</td>
                                                 <td>{{selectedLampDetails.autonomy}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.cu_type=='bluetooth' && selectedLampDetails.gatewayId!=null">
                                                 <td class="labCol">Gateway: </td>
                                                 <td> {{ selectedLampDetails.gatewayId }}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.cu_type=='bluetooth'">
                                                 <td class="labCol">{{this.$t("report_pdf.last_sync")}}</td>
                                                 <td> {{ moment(new Date(selectedLampDetails.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(selectedLampDetails.last_sync)).format('HH:mm:ss') }}</td>
                                             </tr>
                                         </table>
                                         </b-col>
                                     </b-row>
                                 </b-container>
                             </b-tab>

                            <!-- elenco dispositivi posizionati su mappa  -->
                            <b-tab :title="$t('planimetry.tab_list')" lazy @click="resetFilterOnTabChange()">
                                <table class="table tabLampadeDragDrop" >
                                     <thead>
                                         <tr>
                                             <th style="width: 15%"> </th>
                                             <th style="width: 15%">ID</th>
                                             <th style="width: 40%">Desc.</th>
                                             <th style="width: 15%">System</th>
                                             <th style="width: 15%" v-if="this.$store.getters.isCentralized">Central</th>
                                         </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="(lamp,index) in lampsOnMaps" :key="index" :id="'lrow-'+lamp.id" :class="{draggableRow: true, highlightedRow: (selectedLamp != null && selectedLamp.id == lamp.id)}" @click="highlightLamp(lamp,index,$event)" @dragstart="dragLamp(lamp,index,$event)">
                                             <td style="width: 15%">
                                                <i v-if="lamp.device_function=='CU'" class="fa fa-1x fa-tv" style="color:#0090CD;"></i>
                                                <i v-if="lamp.device_function!='CU'" class="fa fa-1x fa-lightbulb" style="color:#0090CD;"></i>
                                            </td>
                                             <td style="width: 15%"><strong>{{lamp.id}}</strong></td>
                                             <td style="width: 40%">{{lamp.desc}}</td>
                                             <td style="width: 15%">{{lamp.cu_type}}</td>
                                             <td style="width: 15%" v-if="lamp.cu_type!='bluetooth'">{{lamp.cu_id.split('#')[1]}}</td>
                                             <!--<td><span class="float-right"><b-button variant="white" class="p-0 m-0"><i class="fa fa-trash" style="color:black" @click="showModalRimuoviLampada(lamp)"></i></b-button></span></td>-->
                                         </tr>
                                     </tbody>
                                 </table>
                             </b-tab>

                             <!-- Posiziona su mappa -->
                            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                                <b-tab v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" :title="$t('planimetry.tab_place')" lazy>
                                    <p>{{$t('planimetry.info_place')}}</p>
                                    <img src="/img/dot_drag.png" style="display: none" />
                                    <img src="/img/dot_drag_emergenza.png" style="display: none" />
                                    <img src="/img/dot_drag_illuminazione.png" style="display: none" />
                                    <img src="/img/dot_drag_altro.png" style="display: none" />


                                    <b-row style="display: flex; align-items: center">
                                        <b-col cols="6">
                                            <b-input-group>
                                            <b-form-input type="text" v-model="filtro_in_tab"></b-form-input>
                                            <!-- Attach Right button -->
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtro=filtro_in_tab"><i class="fa fa-search"></i></b-button>
                                                </b-input-group-append>
                                                       <span class="ml-1" :content="$t('planimetry.search')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009de0"></i></span>
                                            </b-input-group>
                                        </b-col>
                                        <b-col cols="6">
                                            <b-form-select v-model="tipiLampade">
                                                <b-form-select-option value="">{{$t('navbar_dispositivi.all')}}</b-form-select-option>
                                                <b-form-select-option value="emerg">{{$t('navbar_dispositivi.emergency')}}</b-form-select-option>
                                                <b-form-select-option value="illum">{{$t('navbar_dispositivi.lighting')}}</b-form-select-option>
                                                <b-form-select-option value="sens">{{$t('navbar_dispositivi.sensor')}}</b-form-select-option>
                                                <b-form-select-option v-for="cu in this.plantDetails.controlunits" :value="'cu'+cu.cuid" :key="cu.cuid">{{cu.cutype=='blegateway'? 'Gateway' : $t('central_unit')}} {{cu.cuid}}</b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row style="display: flex; align-items: center">
                                        <b-col cols="12" class="float-right mt-4 mb-1">
                                            <b-form-checkbox v-model="filtroLampadeLibere" size="sm" style="display:inline" value="true" @change="filtraLampadeLibere">
                                                <span class="typo-label mr-1" style="font-weight:normal">{{this.$t("planimetry.not_assigned")}}</span>
                                            </b-form-checkbox>
                                        </b-col>
                                    </b-row>

                                    <!--<b-container fluid>-->
                                    <table class="table tabLampadeDragDrop" >
                                        <thead>
                                            <tr>
                                                <th style="width: 10%"> </th>
                                                <th style="width: 15%">ID</th>
                                                <th style="width: 35%">Desc.</th>
                                                <th style="width: 15%">System</th>
                                                <th style="width: 15%" v-if="this.$store.getters.isCentralized">Central</th>
                                                <th style="width: 10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(lamp,index) in allLampsFree" :key="'row-'+index" :id="'lamprow-'+lamp.id" :draggable="!lamp.alreadyAdded && imgLoaded" :class="{draggableRow: true, highlightedAdded:(selectedLamp != null && selectedLamp.id != lamp.id && lamp.alreadyAdded) ,highlightedRow: (selectedLamp != null && selectedLamp.id == lamp.id)}" @click="highlightLamp(lamp,index,$event)" @dragstart="dragLamp(lamp,index,$event)">
                                                <td style="width: 10%">
                                                    <div v-if="lamp.device_function=='CU'"><i class="fa fa-1x fa-tv" style="color:#0090CD;"></i></div>
                                                    <i v-if="lamp.device_function!='CU'" class="fa fa-1x fa-lightbulb" style="color:#0090CD;"></i>
                                                </td>
                                                <td style="width: 15%"><strong>{{lamp.id}}</strong></td>
                                                <td style="width: 35%">{{lamp.desc}}</td>
                                                <td style="width: 15%">{{lamp.cu_type}}</td>
                                                <td style="width: 15%" v-if="lamp.cu_type!='bluetooth'">{{lamp.cu_id.split('#')[1]}}</td>
                                                <td style="width: 10%"><span class="float-right pr-3" ><b-button v-if="lamp.alreadyAdded==true" variant="white" class="p-0 m-0"><i class="fa fa-trash" style="color:black" @click="showModalRimuoviLampada(lamp)"></i></b-button></span></td>
                                            </tr>
                                        </tbody>

                                    </table>
                                    <!--</b-container>-->
                                </b-tab>
                            </show-at>


                         </b-tabs>
                    </b-col>
                </b-row>
            <!-- </b-container> -->
             </div>
        </b-modal>

    <!-- Modal Rimuovi lampada da mappa-->
        <b-modal
            id="modal-remove-lamp"
            ref="modalRemoveLamp"
            centered
            hide-header
            @ok="removeLamp(lampToRemove)"
            @shown="addKeyboardListener"
            @hidden="removeKeyboardListener"
        >
            <h5 v-if="lampToRemove!=null">{{$t('planimetry.remove_lamp',{lamp: lampToRemove.id})}}</h5>
        </b-modal>

    <!-- Modal Disclaimer su upload photo-->
        <b-modal
            ref="modalDisclaimerPhoto"
            id="modal-disclaimer-photo"
            :title="$t('settings.normaTitle')"
            :ok-title="$t('settings.normaAccept')"
            @ok="accettazioneDisclaimerPhoto"
        >
            <label for="typo-label">
            <disclaimer-photo-ITA v-if="$t('language')=='IT'"></disclaimer-photo-ITA>
            <disclaimer-photo-GER v-if="$t('language')=='DE'"></disclaimer-photo-GER>
            <disclaimer-photo-ENG v-else></disclaimer-photo-ENG>
            </label>
        </b-modal>
    <!-- modal che crea un folder -->
    <b-modal
      ref="modalCreateFolder"
      size="lg"
      id="modal-create-folder"
      :title="$t('planimetry.new_folder')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="createFolder"
    >
      <b-row>
      <b-col cols="9">
        <!--input name of folder -->
        <b-form-group class="ml-2">
          <label class="typo-label">{{ $t("planimetry.label_folder_name") }}</label>
          <b-form-input
            v-model="newFolderName"
            type="text"
            @keyup.enter="createFolder"
            autofocus
          ></b-form-input>
         </b-form-group>

        </b-col>
      </b-row>
    </b-modal>



        <!-- <b-modal
          ref="modalCreateFolder"
          id="modal-create-folder"
          :hide-footer="true"
          :title="$t('planimetry.new_folder')"
        >
          <b-row class="mb-4 align-items-center">
            <b-col>
              <b-input-group>
                <b-form-input
                  v-model="newFolderName"
                  placeholder="New folder name..."
                  @keyup.enter="createFolder"
                  autofocus
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-primary" @click="createFolder">Create</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-modal> -->


    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;
import AddToMonitoringZone from '@/components/MonitoringZone/AddToMonitoringZone';

import { mapState } from 'vuex';
import ErrorBanner from '@/components/ErrorBanner';
import draggable from 'vuedraggable';
import { get } from 'jquery';
import { set } from 'core-js/core/dict';
import { template } from 'babel-core';

export default {
    name: 'AmbientiPlanimetrie',
    components: {
        draggable,
        NavBarMain,
        NavBarDispositivi,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoITA,
        DisclaimerPhotoENG,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt,
        showAt,
        AddToMonitoringZone,
        ErrorBanner
    },
    props: ['plantId'],
    data() {
        return {
            section: "ambienti",
            tipiLampade: "",
            highlightedLamp: "",
            filtro: "",
            filtro_in_tab:"",
            tabIndex: 0,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,
            pathMapImages: process.env.VUE_APP_PATH_MAP,
            picLoaded: {},
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            currentAmbiente: {},
            selectedLamp: null,

            theme: 'bootstrap4',
            template: 'default',
            filtroLampadeLibere: false,
            lampToAdd:null,
            modalAddToZone:false,
            resetAddToZone:false,
            alerts:[],
            isDirty: false,
            showReset: false,
            viewfinderStyle: {},
            showMinimap: false,
            selectedMapToImport: null,
            environments: [],
            newFolderName: '',
            openedFolderId: null, //null means we are at the Root level
            folders: [],
            dragOverRoot: false,
            tempFolderName: "",
            editingFolderId: null,
        }

    },

    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),

        // this array contains only the folders that should be shown and reordered
        displayFolders() {
          return this.folders.filter(f => f.id != 'root');
        },
        //ritorna gli oggetti ambienti visibili (o in root o in una cartella)
        visibleAmbientes() {
          return this.currentlyVisibleCardIds
            .map(id => this.ambienteMap[id])
            .filter(amb => !!amb); //remove undefined if map doesn't have the id
        },
        //crea un oggetto così: { "123": {name: "stanza 1, ..."}, "345": {...}}
        ambienteMap() {
          return this.ambienti.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
          }, {});
        },
        // restituisce le card attualmente visibili, cioè quelle di root o quelle in una cartella (folder.ambientesIds)
        currentlyVisibleCardIds: {
          get() {
            const folderId = this.openedFolderId || 'root';
            const folder = this.folders.find(f => f.id === folderId);
            return folder ? folder.ambientesIds : [];
          },
          set(newValue) {
            const targetId = this.openedFolderId || 'root';
            const folder = this.folders.find(f => f.id === targetId);
            if (folder) {
              folder.ambientesIds = newValue;
              this.saveFileSystem();
            }
          }
        },

        currentFolderName() {
          if (this.openedFolderId === null) return "Root";
          const folder = this.folders.find(f => f.id === this.openedFolderId);
          return folder ? folder.name : "";
        },

        //planimetrie/ambienti che non sono dentro a nessun folder
        rootAmbienti() {
          //guard
          if (!this.ambienti) return [];
          const assignedIds = new Set(this.folders.flatMap(f => f.ambientesIds));
          return this.ambienti.filter(a => !assignedIds.has(a.id));
        },

        rndId() {
            return Math.random();
        },

        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        zonesDetails() {
            return this.$store.state.plantZones;
        },
        lampListItems() {
            if (this.currentAmbiente == null || this.currentAmbiente.lamps == null) return [];
            console.log("lampListItems: lamps: ",this.currentAmbiente.lamps);
            return this.currentAmbiente.lamps;
        },
        selectedLampDetails() {
            if (this.selectedLamp == null) return null;
            const selLamp = this.selectedLamp;
            const lampDet = this.allLamps.filter(function (l) {
                return l.id == selLamp.id;
            });
            console.log("selected lamp details:", lampDet);
            if (lampDet != null && lampDet.length > 0) {
                this.unitsDetails.forEach(function (cu) {
                    if (lampDet[0].cu_id == (cu.cu_type+'#'+cu.cu_id))
                        lampDet[0].cu_desc = cu.cu_desc;
                });
                if(lampDet[0].cu_type=='bluetooth')
                {
                    if (lampDet[0].zone_id==null)
                        lampDet[0].zone_id=lampDet[0].cu_id;
                    this.zonesDetails.forEach(function (zone) {
                        if (lampDet[0].zone_id.split('#')[2] == zone.zoneId)
                        {
                            lampDet[0].zoneName = zone.zoneName;
                            lampDet[0].zoneNumber = zone.zoneNumber;
                        }
                    });
                }
                return lampDet[0];
            }
            return null;
        },
        allLamps() {
            var lamps = [];

            var flt = this.filtro;

            var flt2 = this.filtroLampadeLibere;
            var flt3 = this.tipiLampade;

            var cent_to_add=null;

            console.log("ricomputo allLamps, flt3=" + flt3);

            //aggiungi lampade bluetooth
            if (this.zonesDetails != null && this.currentAmbiente != null && this.$store.getters.isBluetooth && !this.$store.getters.isCentralized)
            {
                const llitems = this.lampListItems;
                this.zonesDetails.forEach(function (z) {

                    console.log("zone", z);

                    //bluetooth emergenza
                    if (z.bleLamps != null && z.bleLamps.length > 0 ) lamps = lamps.concat(
                        z.bleLamps.reduce(
                            function(filtered, bleLamp) {

                                var l = bleLamp.lamp;
                                l.id = l.lamp_id;
                                l.gatewayId = z.gatewayId;
                                if (l.device_function == "ILLUMINAZIONE")
                                {
                                    l.potenza_attuale = l.istantaneousPower;
                                    l.energia_consumata = l.energy;
                                    l.TimeOn = l.functionHours;
                                }

                                //aggiungi lampade
                                if(flt3.includes("cu") && z["gatewayId"]!=flt3.replace("cu",""))
                                    return [];
                                if(flt3.includes("emerg") && l.autonomy.includes('?'))
                                    return filtered;
                                if(flt3.includes("illum") && !l.autonomy.includes('?'))
                                    return filtered;
                                if(flt3.includes("sens"))
                                    return [];
                                if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                        console.log("filtered lamp",l);
                                    } else {
                                        return filtered;
                                    }
                                }

                                l["cu_id"].includes(z.zoneId);
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;

                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                //TODO: inserire posizionamento su mappa dei gateway

                                return filtered;
                            }, []
                        )
                    );

                });
            }

            //aggiungi lampade centralizzate
            else if (this.unitsDetails != null && this.currentAmbiente != null) {

                const llitems = this.lampListItems;
                this.unitsDetails.forEach(function(u) {

                    //emergency lamps in cablecom, logica, logicafm
                    if ((flt3 == "" || flt3 == "emerg" || flt3.includes("cu")) && u.lamps != null && u.lamps.length > 0 && u.cu_type!="sicuro") lamps = lamps.concat(
                        u.lamps.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0)
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }
                                l["device_function"]="EMERGENZA";
                                if(l["cu_type"]=="bluetooth" && l["cu_id"].includes("ble#"))
                                {
                                    l["zone_id"]=l["cu_id"];
                                    l["cu_id"]="blegateway#"+u.id;
                                }


                                //aggiungi lampade
                                if(flt3.includes("cu") && l["cu_id"].split('#')[1]!=flt3.replace("cu",""))
                                    return [];
                                else
                                    //console.log("id lamp filtered for cent", l.id);
                                if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                        console.log("filtered lamp",l);
                                    } else {
                                        return filtered;
                                    }
                                }

                                //l["cu_id"] = u.cu_id;
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;

                                //se è abilitato il filtro sulle lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }


                                return filtered;
                            }, []
                        )
                    );

                    //emergency lamps in sicuro
                    if ((flt3 == "" || flt3 == "emerg" || flt3.includes("cu")) && u.cu_type=="sicuro" && (u.ak.length+u.ak_ext.length)>0)
                    {

                        u.ak.forEach((ak_item)=>{
                                ak_item.lines.forEach((line)=>{
                                   lamps = lamps.concat (
                                            line.lamps.reduce(
                                                function(filtered, l) {

                                                    //aggiungi le centrali da posizionare
                                                    if(cent_to_add!=u)
                                                    {
                                                    cent_to_add=u;
                                                    cent_to_add.id=cent_to_add.cu_id;
                                                    cent_to_add.desc=cent_to_add.cu_desc;
                                                    cent_to_add.device_function="CU";
                                                    const acent = llitems.filter(function(al) {
                                                        return (al.id == u.id);
                                                            })
                                                    if (acent != null && acent.length > 0)
                                                        cent_to_add.alreadyAdded = true;
                                                    else
                                                        cent_to_add.alreadyAdded = false;
                                                    filtered.push(cent_to_add);
                                                    }

                                                    l.id=l.lamp_id;
                                                    if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                                        return [];
                                                    if (flt != null && flt != "") {
                                                        if (l.id.includes(flt.toUpperCase())) {
                                                            console.log("filtered",flt);
                                                            console.log("filtered lamp",l);
                                                        } else {
                                                            return filtered;
                                                        }
                                                    }

                                                    // l["cu_id"] = u.cu_id;
                                                    var alreadyAdded = false;
                                                    const alamp = llitems.filter(function(al) {
                                                        return (al.id == l.id);
                                                    })
                                                    if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                                    l["alreadyAdded"] = alreadyAdded;

                                                    //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                                    if (flt2=='true')
                                                    {
                                                        if(l.alreadyAdded==false)
                                                            filtered.push(l);
                                                    }
                                                    else
                                                    {
                                                        filtered.push(l);
                                                    }

                                                    //aggiungi le centrali da posizionare
                                                    if(cent_to_add!=u)
                                                    {
                                                    cent_to_add=u;
                                                    cent_to_add.id=cent_to_add.cu_id;
                                                    cent_to_add.desc=cent_to_add.cu_desc;
                                                    cent_to_add.device_function="CU";
                                                    const acent = llitems.filter(function(al) {
                                                        return (al.id == u.id);
                                                            })
                                                    if (acent != null && acent.length > 0)
                                                        cent_to_add.alreadyAdded = true;
                                                    else
                                                        cent_to_add.alreadyAdded = false;
                                                    filtered.push(cent_to_add);
                                                    }

                                                    return filtered;
                                                }, []
                                             )
                                    )
                                });
                            });

                            u.ak_ext.forEach((ak_item)=>{
                                ak_item.lines.forEach((line)=>{
                                   lamps = lamps.concat (
                                            line.lamps.reduce(
                                                function(filtered, l) {
                                                    l.id=l.lamp_id;
                                                    if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                                        return [];
                                                    if (flt != null && flt != "") {
                                                        if (l.id.includes(flt.toUpperCase())) {
                                                            console.log("filtered",flt);
                                                            console.log("filtered lamp",l);
                                                        } else {
                                                            return filtered;
                                                        }
                                                    }

                                                    // l["cu_id"] = u.cu_id;
                                                    var alreadyAdded = false;
                                                    const alamp = llitems.filter(function(al) {
                                                        return (al.id == l.id);
                                                    })
                                                    if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                                    l["alreadyAdded"] = alreadyAdded;

                                                    //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                                    if (flt2=='true')
                                                    {
                                                        if(l.alreadyAdded==false)
                                                            filtered.push(l);
                                                    }
                                                    else
                                                    {
                                                        filtered.push(l);
                                                    }


                                                    return filtered;
                                                }, []
                                             )
                                    )
                                });
                            });
                    }

                    if ((flt3 == "" || flt3 == "illum" || flt3.includes("cu")) && u.lamps_illum != null && u.lamps_illum.length > 0) lamps = lamps.concat(
                        u.lamps_illum.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0)
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }

                                l["device_function"]="ILLUMINAZIONE";
                                if(l["cu_type"]=="bluetooth" && l["cu_id"].includes("ble#"))
                                {
                                    l["zone_id"]=l["cu_id"];
                                    l["cu_id"]="blegateway#"+u.id;
                                }


                                //aggiungi lampade
                                if(flt3.includes("cu") && l["cu_id"].split('#')[1]!=flt3.replace("cu",""))
                                    return [];
                                    if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                    } else {
                                        return filtered;
                                    }
                                }

                                // l["cu_id"] = u.cu_id;
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;

                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                return filtered;
                            }, []
                        )
                    );

                    if ((flt3 == "" || flt3 == "sens"|| flt3.includes("cu")) && u.sensors != null && u.sensors.length > 0) lamps = lamps.concat(
                        u.sensors.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0)
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }

                                if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                    return [];
                                    if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                    } else {
                                        return filtered;
                                    }
                                }

                                // l["cu_id"] = u.cu_id;
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;

                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                return filtered;
                            }, []
                        )
                    );


                });
            }
            console.log("all lamps:",lamps);
            return lamps;
        },
        //restituisce un array con tutti gli oggetti (centrali e lampade) presenti nella planimetria
        lampsOnMaps(){
            var lamps_on_maps=[];
            lamps_on_maps= this.allLamps.filter (function(lamp)
            {
                if(lamp.cu_id.includes("sicuro"))
                    lamp.id=lamp.lamp_id;
                return (lamp.alreadyAdded == true);
            });
            console.log("lamps on maps",lamps_on_maps);
            return lamps_on_maps;
        },
        //
        idsOnMap() {
          return this.lampsOnMaps.map(item => item.id);
        },

        //----------------------------------------------------------------------------------------
        // Funzione che aggiorna gli ambienti con lo stato corrente dei dispositivi dell'impianto: verificano se ci siano ancora o meno,
        // e se ci sono errori o anomalie, in modo da mostrare la situazione più aggiornata possibile all'interno delle mappe
        //----------------------------------------------------------------------------------------
        ambienti() {
            if (this.plantDetails == null || this.plantDetails[this.section] == null) return [];
            let self = this;

            //self.allLampsPlaced=[];
            console.log("lista ambienti: ", this.plantDetails[this.section]);
            let envs = this.plantDetails[this.section].map(function(a) {
                //console.log("mappo " + self.section, a);
                //safety check
                let rawLamps = a.lamps || [];
                let lamps1 = rawLamps.filter(function(l) {
                    //console.log("mappate ",l.id, l.tipo);
                    if(l.tipo=="cu")
                        return self.findCu(l.id) !=null;
                    else
                        return self.findLamp(l.id) != null;
                });

                let lamps = lamps1.map(function(l){
                    //trovo la lampada
                    var status = "ok";
                    var emergency ="off";
                    let lampInfo = l.tipo=="cu"?  self.findCu(l.id) : self.findLamp(l.id);

                    if (lampInfo != null) {
                        if (self.hasOrphan(lampInfo)) status = 'orphan';
                        else if (self.hasError(lampInfo)) status = 'err';
                        else if (self.hasErrorCom(lampInfo)) status = 'errcom';

                        if(self.isInEmergency(lampInfo)) emergency ='on'
                    }

                    return {id: l.id, status: status, px: l.px, py: l.py, selected: false, tipo: self.tipoLamp(lampInfo), emergency: emergency}
                })
                //a.lamps = lamps;
                //console.log("lamps in ambient_planimetry ", a.name , " : ", a.lamps);
                //self.allLampsPlaced=self.allLampsPlaced.concat(a.lamps);
                //console.log("all lamps placed: ",self.allLampsPlaced);
                //return a;
                return {...a, lamps: lamps};
            });
            console.log("ambienti con lampade:",envs);
            return envs;
        },
        //computed property che sfrutta ambienti() per ricavare la lista aggiornata delle lampade già posizionate
        allLampsPlaced() {
          let listLamps = this.ambienti.flatMap( ambiente => {
            return ambiente.lamps.map(lamp => lamp.id);
          });
          console.log("lampade già posizionate: ", listLamps);
          return listLamps;
        },
        //computed property che restituisce la lista delle lampade free
        allLampsFree() {
          const placedLamps = new Set(this.allLampsPlaced); //.map(lamp => lamp.id));
          let lampsfree= this.allLamps.filter(item => !placedLamps.has(item.id ? item.id : item.lamp_id) || this.idsOnMap.includes(item.id ? item.id : item.lamp_id));
          console.log("lampade libere: ", lampsfree);
          return lampsfree;
        }

    },
    async mounted() {
        console.log("AmbientiPlanimetrie mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails)
        console.log("router-->", this.$router);
        this.section = this.$router.currentRoute.name.toLowerCase();
        console.log("sezione ambienti/planimetrie=" + this.section);
        window.addEventListener('resize', this.handleResize);
        if (this.$store.state.user != null && this.error == null && this.$store.getters.isBluetooth && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            if (this.$store.state.plantZones == null)
            {
                this.$store.dispatch('loadPlantZones', this.plantId)
            }
            else
            {
                console.log("aggiornato plant zones", this.zonesDetails);
            }
        }
        else if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            if (this.$store.getters.isBluetooth)
            {
                if (this.$store.state.plantZones == null) {
                    this.$store.dispatch('loadPlantZones', this.plantId)
                }
            }
            else
                this.$store.dispatch('loadPlantDetails', this.plantId)
        } else {
            let self = this;
            this.$nextTick(() => {
                self.$forceUpdate();
            });
        }
        // Call the method to load fonts when the component is mounted
        await this.loadFonts();
    },
    updated() {
        //console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        if(this.tabIndex!=2)
            {
                this.filtroLampadeLibere=false;
                this.filtro="";

        }

        /*if (this.plantDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        } */
    },

    watch: {
        loading(val) {
            console.log("loading changed:" + val+", error=" + this.error)
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
             } else if (val == false && this.plantDetails != null && this.$store.getters.isBluetooth && this.zonesDetails == null && this.error == null) {
                console.log("carico zone details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
                this.$store.dispatch('loadPlantZones', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("devo elaborare risposta comando ", this.$store.state.commandResponse);
                /*var alert = {
                    timeLeft: 5,
                    msg: "Eseguito comando " + this.$store.state.commandResponse.command + " su centrale " + this.$store.state.commandResponse.cu,
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);*/
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti lampade centralizate");
            }  else if (val == false && this.plantDetails != null && this.zonesDetails != null) {
                console.log("dati pronti zone bluetooth");
            }
            this.$forceUpdate();
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);

        },
        commandResponse(val) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.addMap();
            }
        },

        // 'immediate: true' fa sì che l'handler venga eseguito immediatamente quando il componente viene creato per la prima volta.
        // Questo è fondamentale perché vogliamo che l'array this.allLampsPlaced sia popolato con i dati iniziali non appena il componente è pronto,
        // non solo dopo che i dati cambiano.
        ambienti: {
            immediate: true,
            handler(newVal) {
              if (newVal) this.initFileSystem();
            }
        },
        plantDetails: {
          immediate: true,
          handler(newVal) {
            if (newVal) this.initFileSystem();
          }
        }
    },
    methods: {
        //init del filesystem delle planimetrie
        initFileSystem() {
          // Guard
          if (!this.plantDetails || !this.ambienti) {
            return;
          }
          // Initialization logic
          // 1. Load folders into localstate if empty
          // check if we only have the 'root' virtual folder we created
          if (this.folders.length <= 1) {
            const savedFolders = this.plantDetails[this.section + '_folders'];
            if (savedFolders && savedFolders.length > 0) {
              //use deep copy to break reference with the store
              this.folders = JSON.parse(JSON.stringify(savedFolders));
            }
          }
          // 2. Create the folder 'root' if it doesn't exist
          let rootFolder = this.folders.find(f => f.id === 'root');
          if (!rootFolder) {
            rootFolder = { id: 'root', name: 'Home', ambientesIds: [] };
            this.folders.unshift(rootFolder);
          }

          // Sync IDs
          // 3. Map existing assigned IDs for quick lookup
          const assignedIds = new Set(this.folders.flatMap(f => f.ambientesIds.map(id => Number(id))));
          // 4. Find maps that are NOT assigned anywhere yet
          const newUnassignedIds = this.ambienti
            .map(amb => Number(amb.id))
            .filter(id => !assignedIds.has(id));

          // 5. Add these maps to the root folder
          if (newUnassignedIds.length > 0) {
            rootFolder.ambientesIds.push(...newUnassignedIds);
          }
        },
        //per rinmianre un folder
        startRename(folder) {
          this.editingFolderId = folder.id;
          this.tempFolderName = folder.name;
        },
        saveRename(folder) {
          if (this.tempFolderName.trim() !== "" && this.tempFolderName !== folder.name) {
            folder.name = this.tempFolderName;
            this.saveFileSystem();
          }
          this.editingFolderId = null;
        },
        openFolder(folderId) {
          this.openedFolderId = folderId;
        },
        goBack() {
          this.openedFolderId = null;
        },
        getAmbienteById(id) {
          return this.ambienti.find(env => env.id === id);
        },
        //elimina una cartella
        removeFolder(folderId) {
          // 1. Find the folder and its index
          const index = this.folders.findIndex(f => f.id === folderId);
          if (index === -1) return;

          const folder = this.folders[index];
          // 2. Confirm deletion
          const msg = this.$t("planimetry.confirm_delete_empty_folder", {folder: folder.name});
          this.$bvModal.msgBoxConfirm(msg, {
            title: this.$t("planimetry.title_delete_folder"),
            okVariant: 'danger',
            okTitle: this.$t("settings.delete"),
            cancelTitle: this.$t("cancel"),
            centered: true
          }).then((value) => {
              if (value === true) {
                // 3. Move items back to Root (Desktop)
                if (folder.ambientesIds && folder.ambientesIds.length > 0) {
                  //we add them to rthe root so they will appear on the 'Desktop'
                  this.folders.find(f => f.id === 'root').ambientesIds.push(...folder.ambientesIds);
                }
                // 4. Remove the folder from the array
                this.folders.splice(index, 1);
                // 5. If we were inside that folder, go back to Root
                if (this.openedFolderId === folderId) {
                  this.goBack();
                }
                // 6. Persist the change
                this.saveFileSystem();
              }
          });
        },
        addKeyboardListener() {
          window.addEventListener('keydown', this.onKeyPress);
        },
        removeKeyboardListener() {
          window.removeEventListener('keydown', this.onKeyPress);
        },
        onKeyPress(event) {
            // Check if the pressed key is the Enter key
            if (event.key === 'Enter') {
                this.removeLamp(this.lampToRemove);
                this.$bvModal.hide('modal-remove-lamp');
            }
        },
        //importa l'array lamps dalla mappa selezionata e lo pone in questa mappa, aggiungendole a quelle eventualmente presenti
        importaLampadeFromSelectedMap() {
            //selectedMapToImport contiene l'id dell'ambiente selezionato
            if (!this.selectedMapToImport) return; // safety check: no map selected
            const id =this.selectedMapToImport;
            const sourceAmbiente = this.ambienti.find(a => a.id === id);
            // Safety check: avoid 'undefined' crashes
            if (!sourceAmbiente || !sourceAmbiente.lamps) return;
            if (!this.currentAmbiente.lamps) this.$set(this.currentAmbiente, 'lamps', []);

            // Create a Set of existing IDs for O(1) lookup speed
            const existingIds = new Set(this.currentAmbiente.lamps.map(item => item.id));
            //const addedIds = new Set();
            let addedCount = 0;
            sourceAmbiente.lamps.forEach(l => {
                if (!existingIds.has(l.id)) {
                    this.currentAmbiente.lamps.push({...l});
                    existingIds.add(l.id); // sicurezza, per evitare incongruenze
                    addedCount++;
                }
            });

            if (addedCount > 0) {
                this.markAsDirty();
                console.log(`Added ${addedCount} new lamps to the current map.`);
            }



            // const id =this.selectedMapToImport;
            // this.ambienti.find(a => a.id == id).lamps.forEach(l => {
            //     //verifico che non sia già stata importata
            //     if(!this.currentAmbiente.lamps.some(item => item.id === l.id))
            //     {
            //         console.log("importata lampada " + l.id);
            //         //uso una shallow copy invece che un reference (funziona comunque perché le coordinate sono proprie di ogni mappa)
            //         this.currentAmbiente.lamps.push({...l});
            //         this.markAsDirty();
            //     }
            // })
        },
        //import lamps from another map
        importaLampade() {
            this.$bvModal.show('selection-modal');
        },

        //funzione che segnala una modifica in una mappa
        markAsDirty() {
            this.isDirty = true;
        },
        //----------------------------------------------------------------------------
        // Resetta lo zoom riposizionando correttamente le icone
        //----------------------------------------------------------------------------
        resetZoomToZero() {
            if (this.$refs.zoomContainer && this.$refs.zoomContainer.$panZoomInstance) {
                console.log("Resetting zoom to initial position and scale.");
                // Reset to initial position and scale using absolute methods
                const instance = this.$refs.zoomContainer.$panZoomInstance;
                instance.moveTo(0, 0);
                instance.zoomAbs(0, 0, 1); // x, y, absolute scale
                const transform = instance.getTransform();
                while (transform.x !== 0 || transform.y !== 0 || transform.scale !== 1) {
                    console.warn("Transform not reset yet, retrying...");
                    instance.moveTo(0, 0);
                    instance.zoomAbs(0, 0, 1); // x, y, absolute scale
                }
                this.showReset = false;
            }
        },

        //Loads all required fonts and stores them in component data.
        async loadFonts() {
            try {
                // Assumes fonts are in your 'public' folder
                this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
                this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
                //console.log('Fonts loaded successfully.');
            } catch (error) {
                console.error('Failed to load fonts:', error);
            }
        },
        // Helper function to load a font from a URL and convert it to Base64
        async loadFontAsBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Get the Base64 string, but strip the "data:..." prefix
                    const base64data = reader.result.split(',')[1];
                    resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0)
            {
               return user[0].role;
            }
            return "?";
        },
        resetFilterOnTabChange()
        {
            this.tipiLampade="";
        },
        showAddToMonitoringZone(lampMonitor)
        {
           this.lampToAdd = lampMonitor;
           this.modalAddToZone = true;
        },
        //funzione che genera un file pdf con la mappa e le lampade posizionate
        async generaPdfMappa() {
            // Define the target icon size as a percentage of the map height
            const ICON_SIZE_PERCENT = 4.0;
            //massima dimensione in px del canvas
            const MAX_DIM = 4000;

            let self = this;
            console.log("genero pdf mappa");

            //var mappa = document.createElement("img");

            var lampOK = document.createElement("img");
            lampOK.src = "/img/dot_ok.png";
            var lampERR = document.createElement("img");
            lampERR.src = "/img/dot_err.png";
            var lampERRCOM = document.createElement("img");
            lampERRCOM.src = "/img/dot_errcom_emergenza.png";
            var illumOK = document.createElement("img");
            illumOK.src = "/img/dot_ok_illuminazione.png";
            var illumERR = document.createElement("img");
            illumERR.src = "/img/dot_err_illuminazione.png";
            var illumERRCOM = document.createElement("img");
            illumERRCOM.src = "/img/dot_errcom_illuminazione.png";
            var centOK = document.createElement("img");
            centOK.src = "/img/dot_ok_cu.png";
            var centERR = document.createElement("img");
            centERR.src = "/img/dot_err_cu.png";
            var centOFFLINE = document.createElement("img");
            centOFFLINE.src = "/img/dot_offline_cu.png";
            var lampORPHAN = document.createElement("img");
            lampORPHAN.src = "/img/dot_orphan_emergenza.png";
            var illumORPHAN = document.createElement("img");
            illumORPHAN.src = "/img/dot_orphan_illuminazione.png";

            //scarico la mappa dal server passando dall'API Gateway e dalla Lambda main
            let planUrl = `${process.env.VUE_APP_API_REST_URL}?action=getResource&type=${this.section}&id=${this.plantId}-${this.currentAmbiente.id}`;
            console.log("planUrl=" + planUrl);

            const mappa = new Image();
            // 1. set CORS policy before the source
            mappa.crossOrigin="anonymous";
            // 2. Create a Promise to handle the load
            const loadPlanimetria = new Promise((resolve, reject) => {
              const timeout = setTimeout(() => reject(new Error("Timeout")), 15000); //limite di attesa max di 15s

              mappa.onload = () => {
                clearTimeout(timeout);
                resolve();
              };

              mappa.onerror = () => {
                clearTimeout(timeout);
                reject(new Error("Failed to load image"));
              };

              //aggiungiamo un cache-buster
              mappa.src = planUrl + "&t=" + new Date().getTime();
            });

            try {
              //wait for the load
              await loadPlanimetria;
              console.log("Map image loaded successfully:", mappa.width, "x", mappa.height);
            } catch (error) {
              console.error("Error loading map image:", error);
              alert("Errore nel caricamento della mappa. Impossibile generare il PDF.");
              return;
            }
            // // 2. set the source
            // mappa.src = planUrl;
            // try {
            //   await mappa.decode();
            // } catch (error) {
            //   console.error("Error loading map image:", error);
            //   alert("Errore nel caricamento della mappa. Impossibile generare il PDF.");
            //   return;
            // }

            // Calcolo delle dimensioni di stampa (dimensione fisica in CM sulla pagina PDF)
            var imgAspect = mappa.width / mappa.height;
            var pageAspect = 26.0 / 19.0

            console.log("immagine:" + mappa.width + "x" + mappa.height + ", aspect:" + imgAspect+", page aspect:" + pageAspect);

            var pw = 0;
            var ph = 0;
            if (imgAspect > pageAspect) {
                pw = 26.0;
                ph = 26.0 / imgAspect;
            } else {
                ph = 19.0;
                pw = 19.0 * imgAspect;
            }

            // var pAspect = pw / ph;

            // console.log("dimensioni stampa:" + pw + "x" + ph + ", aspect:" + pAspect);

            // const iconSize = Math.round((ICON_SIZE_PERCENT / 100) * mappa.height);
            // var canvas = document.createElement("canvas");
            // canvas.width = mappa.width;
            // canvas.height = mappa.height;

            // // Copy the image contents to the canvas
            // var ctx = canvas.getContext("2d");
            // ctx.drawImage(mappa, 0, 0);

            // Calcolo della risoluzione dell'immagine in pixel
            // per efficienza e per evitare lavoro inutile a jsPdf, con possibili errori,
            // limitiamo il canvas, su cui inserire l'immagine scaricata, a 4000px, misura più
            // che sufficiente per ottenere un'ottima qualità di immagine nei PDF
            let scale = 1;
            if (mappa.width > MAX_DIM || mappa.height > MAX_DIM) {
              scale = Math.min(MAX_DIM / mappa.width, MAX_DIM / mappa.height);
            }
            // calcolo la dimensione del canvas in base alla scala
            const canvasWidth = mappa.width * scale;
            const canvasHeight = mappa.height * scale;
            // aggiorno la dimensione delle icone rispetto all'altezza del canvas
            const iconSize = Math.round((ICON_SIZE_PERCENT / 100) * canvasHeight);
            // creo il canvas con le dimensioni adeguate
            var canvas = document.createElement("canvas");
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;

            var ctx = canvas.getContext("2d");
            // disegno l'immagine nel canvas: il browser si occupa di fare il downsampling nel caso di immagini molto grandi
            ctx.drawImage(mappa, 0, 0, canvasWidth, canvasHeight);

            // Disegno le lampade sulla mappa
            var nDisp = self.currentAmbiente.lamps.length;

            // Update the text size and positioning as well (using iconSize or a factor of it):
            ctx.font = `bold ${iconSize * 0.5}px Roboto, Arial, Helvetica`; // Make font relative to icon size
            // Position text relative to the new icon size (e.g., 10px offset from icon center)
            const textOffsetX = iconSize * 0.6;
            const textOffsetY = iconSize * 0.7;

            for (var l=0; l<nDisp; l++) {
                var lamp = self.currentAmbiente.lamps[l];
                var deviceIcon = null;
                console.log("lamp:",lamp.id, "status:", lamp.status, "type:", lamp.tipo);
                if (lamp.tipo === 'cu') {
                  deviceIcon = (lamp.status === 'ok') ? centOK : (lamp.status === 'offline') ? centOFFLINE : centERR;
                } else if (lamp.tipo === 'emergenza') {
                  deviceIcon = (lamp.status === 'ok') ? lampOK : (lamp.status === 'orphan') ? lampORPHAN : (lamp.status === 'errcom') ? lampERRCOM : lampERR;
                } else if (lamp.tipo === 'illuminazione') {
                  deviceIcon = (lamp.status === 'ok') ? illumOK : (lamp.status === 'orphan') ? illumORPHAN : (lamp.status === 'errcom') ? illumERRCOM : illumERR;
                }

                if (deviceIcon) {
                  // const x = lamp.px * mappa.width / 100.0;
                  // const y = lamp.py * mappa.height / 100.0;
                  const x = (lamp.px * canvasWidth) / 100.0;
                  const y = (lamp.py * canvasHeight) / 100.0;

                  //Draw icon with shadow
                  ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'; //dark shadow
                  ctx.shadowBlur = 4;
                  ctx.drawImage(deviceIcon, x - (iconSize / 2), y - (iconSize / 2), iconSize, iconSize);

                  // RESET shadow immediately so it doesn't affect the text
                  ctx.shadowColor = 'transparent';
                  ctx.shadowBlur = 0;

                  //Draw Text (shadow effect using offset)
                  ctx.fillStyle = "#FFFFFF"; //white shadow
                  ctx.fillText(lamp.id, x - textOffsetX - 1, y - textOffsetY - 1);
                  ctx.fillStyle = "#000000";
                  ctx.fillText(lamp.id, x - textOffsetX, y - textOffsetY);
                }
            }

            //var dataURL = canvas.toDataURL("image/png").replace(/^data:image\/(png|jpg);base64,/, "");
            var dataURL = canvas.toDataURL("image/png");

            console.log("currentPlant",self.$store.state.currentPlant,self.currentAmbiente );
            var doc = new jsPDF('p', 'pt');

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            // Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

            doc.setFont('Roboto', 'bold');

            doc.setFontType("bold");
            doc.setFontSize(14);
            doc.text("Impianto: " + self.$store.state.currentPlant.plantname,29,28);
            doc.text("Ambiente: " + self.currentAmbiente.name,29,48);

            // Disegnamo nel PDF trasformando i cm in pt (1cm equivale a circa 28.346pt)
            doc.addImage(
              dataURL,
              "PNG",
              29,                 // x
              70 - (ph * 28.3),   // y
              pw * 28.3,          // width in points
              ph * 28.3,          // height in points
              "map",
              "FAST",
              -90                 // rotation
            );
            doc.addPage();

            var columns = [
                {title: self.$t('details_lamp.lamp_id'), dataKey: "id"},
                {title: self.$t('details_lamp.lamp_desc'), dataKey: "desc"},
                {title: self.$t('details_lamp.lamp_code'), dataKey: "code"},
                {title: self.$t('details_lamp.lamp_type'), dataKey: "type"},
                {title: self.$t('details_lamp.central_type'), dataKey: "cent_type"},
                {title: self.$t('details_lamp.central_id'), dataKey: "cent_id"},
            ];

            var rows = [];
            for (l=0; l<nDisp; l++) {
                if (self.currentAmbiente.lamps[l].tipo=="cu")
                    continue;
                lamp = self.findLamp(self.currentAmbiente.lamps[l].id);
                console.log("lamp",lamp);
                rows.push({
                    id: lamp.id ,
                    desc: lamp.desc,
                    code: lamp.order_code,
                    type: lamp.lamp_type,
                    cent_type: lamp.cu_type,
                    cent_id: lamp.cu_id
                });
            }

            doc.autoTable({
                columns,
                body: rows,
                startY: 28,
                theme: 'striped',
                styles: {
                        fontSize: 7,
                        //font: "helvetica", // helvetica, times, courier
                        font: 'Roboto',
                        fontStyle: 'normal', // normal, bold, italic, bolditalic
                        halign: 'left', // left, center, right
                },
                headStyles: {},
                bodyStyles: {},
                alternateRowStyles: {},
                columnStyles: {}
            });


            doc.save("plant_export_" + self.currentAmbiente.name + ".pdf");

            // }
        },
        getMappeLamp(lamp) {
            if (this.ambienti == null || this.ambienti.length == 0) return "";
            var mappe = "";
            for (var a = 0; a < this.ambienti.length; a++) {
                var amb = this.ambienti[a];
                if (amb.lamps != null && amb.lamps.length > 0){
                    for (var l=0; l<amb.lamps.length; l++) {
                        var ll = amb.lamps[l];
                        if (ll.id == lamp.id) {
                            mappe += ", " + amb.name
                        }
                    }
                }
            }
            if (mappe.length > 2) return mappe.substr(2);
            return mappe;
        },
        filtraLampadeLibere(value) {
            this.filtroLampadeLibere=value;
            this.$nextTick(() => {
                console.log("filtro lampade libere:" , this.filtroLampadeLibere);
            });

        },
        evidenzia() {

            if (this.highlightedLamp != "" && this.highlightedLamp.length == 4) {
                console.log("evidenzio " + this.highlightedLamp);
            }
        },

        zooming(srcObj) {
          let bgElem = document.getElementById("imgBig");
          if (!bgElem) return;

          let tr = srcObj.getTransform();

          console.log("zoom: ", tr.scale);


          // We no longer need to manually move dots.
          // They are children of the zoomed container, so they move automatically

          // Viewfinder logic is still needed because the viewfinder is outside the zoom container
          // Viewfinder Logic
          // We calculate how much of the image is hidden based on the scale and offset
          // tr.x is negative when we pan right, so we negate it to get positive offset
          // tr.y is negative when we pan down, so we negate it to get positive offset
          const percentX = (-tr.x / (bgElem.clientWidth * tr.scale)) * 100;
          const percentY = (-tr.y / (bgElem.clientHeight * tr.scale)) * 100;

          this.viewfinderStyle = {
              width: (100 / tr.scale) + '%',
              height: (100 / tr.scale) + '%',
              left: percentX + '%',
              top: percentY + '%',
          }
          //se lo zoom è maggiore di 1, abilito il pulsante di reset
          this.showReset = tr.scale > 1.01 || Math.abs(tr.x) > 1 || Math.abs(tr.y) > 1;

          //icon scaling
          const iconScale = Math.pow(1 / tr.scale, 0.7);

          //quando si userà iconScale, occorrerà utilizzare Math.pow o un moltiplicatore per evitare che con zoom = 0.2 siano troppo piccole
          //e che con zoom=10 siamo abbastanza piccole
          //si applica a panZoom, il container, in modo che venga ereditato da tutte le icone
          const container = document.getElementById('zoomContainer');
          if (container) {
            container.style.setProperty('--icon-scale', iconScale);
          }
        },

        findLamp(id) {
            //console.log("ricerca lampada per mappa, id:",id);
            var lamp = null;

            //Se l'impianto ha comunque delle zon bluetooth con delle lampade cerca anche tra le zone bluetooth
            if (this.$store.getters.isBluetooth && this.zonesDetails != null)
            {
                var trovato = false;
                this.zonesDetails.some(function (z) {
                    z.bleLamps.some(function (l) {
                        if (l.id == id)
                        {
                            lamp = l.lamp;
                            lamp.id = id;
                            lamp.zoneName = z.zoneName;
                            lamp.device_function = lamp.autonomy.includes("H") ? "EMERGENZA" : "ILLUMINAZIONE";
                            trovato = true;
                        }
                        return trovato;
                    });
                    return trovato;
                });
            }

            //Se non ci sono control units , l'impianto è solo bluetooth quindi termina
            if (this.unitsDetails == null) return null;

            //Se ci sono control units cerca tra le lampade centralizzata ma non considerare quelle gestite da gateway ble
            //perchè già considerate nel primo ciclo tra le zone bluetooth
            this.unitsDetails.some(u => {
                    let candidateArrays = [];

                    if(u.cu_type!="blegateway")     //no se lampade bluetooth
                    {
                            if (u.cu_type === "sicuro") {
                                // Flatten the nested lamps from ak and ak_ext
                                candidateArrays = [
                                    ...(u.ak || []).flatMap(ak_item => (ak_item.lines || []).flatMap(line => line.lamps || [])),
                                    ...(u.ak_ext || []).flatMap(ak_item => (ak_item.lines || []).flatMap(line => line.lamps || []))
                                ];

                            } else {
                                // Concatenate all direct lamp/sensor arrays
                                candidateArrays = [
                                    ...(u.lamps || []),
                                    ...(u.lamps_illum || []),
                                    ...(u.sensors || [])
                                ];
                            }

                            //console.log("Searching in unit:", u.cu_id, "Candidate lamps/sensors:", candidateArrays);
                            // Search the combined array for the lamp ID
                            const foundLamp = candidateArrays.find(l => l.lamp_id === id || l.id === id);

                            if (foundLamp) {
                                lamp = foundLamp;
                                return true; // Stop the outer unitsDetails.some() loop
                            }
                            return false;
                    }
                });

            //console.log("lamp found for map: ",lamp);
            return lamp;
        },
        findCu(id) {
            var cu = null;
            if (this.unitsDetails == null) return null;
            this.unitsDetails.forEach(function(u){
                    if (u.cu_id == id)
                    {
                        cu=u;
                        cu.device_function="CU";
                    }
               })
            return cu;
        },
        apertoDettaglioMappa() {
            console.log("Aperto dettaglio " + this.currentAmbiente.isNew);
            this.tabIndex = 0;
            this.selectedLamp = null;
            if (this.currentAmbiente.isNew) {
                this.showDropZone = true;
            }
        },
        showModalDisclaimer()
        {
            var acceptedDate= new Date(this.$store.state.user.disclaimerPhotoAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("DisclaimerPhoto già accettata in data",acceptedDate);
                this.addMap();
            }
            else
            {
                this.$refs['modalDisclaimerPhoto'].show();
            }
        },
        accettazioneDisclaimerPhoto()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione disclaimer",actualDate);
           this.$store.dispatch('dbSaveDisclaimerPhoto',{acceptedDate: actualDate});
        },

        addMap() {
          const plant = this.$store.state.currentPlant;
          var mappe = plant[this.section];
          console.log("addMap, mappe:", mappe);
          let numMappe = (mappe != null) ? mappe.length : 0;
          // 1. PRO/Basic limit checks
          if (this.$store.getters.isProExpired  || plant.plant_type == 'basic') {
              if (numMappe >= this.$store.state.appConfig.maxPlants) {
                  this.$bvModal.msgBoxConfirm(this.$t("planimetry.pro_expired"), {
                      title: this.$t("planimetry.title_pro_expired", {ambienti: this.section}),
                      okVariant: 'success',
                      okTitle: plant.plant_type == 'basic' ? this.$t('planimetry.passa_pro') : this.$t('planimetry.rinnova_pro'),
                      cancelTitle: this.$t('close'),
                      centered: true
                  }).then((value) => {
                      if (value == true) {
                      //this.$root.$emit('openSettingsEvent');
                      this.$router.push({
                          name: "GeneraliImpianto",
                          params: { plantId: this.$store.state.currentPlant.id }
                      });
                      }
                  });
                  return;
              }
          }
          // 2. Create the new map object
          const newId = Date.now(); //more robust than Math.random
          const pianta = {
              id: newId,
              name: "",
              lamps: [],
              isNew: true
          };
          // 3. Ensure the section exists in the store, otherwise add it
          if (mappe === null || mappe === undefined)  {
              Vue.set(this.$store.state.currentPlant,this.section,[]);
              mappe = this.$store.state.currentPlant[this.section];
          }
          // 4. Push to the main maps list
          mappe.push(pianta);

          // 5. Add to Root view (desktop)
          this.folders.find(f => f.id === 'root').ambientesIds.push(newId);

          // 6. Open the modal using the ID
          this.imgUploaded = false;
          this.apriModalById(newId);

        },
        //funzione che aggiunge una cartella in cui inserire le planimetrie/ambienti
        //poi la apre
        addFolder() {
          this.$bvModal.show('modal-create-folder');
        },
        createFolder() {
          if (!this.newFolderName.trim()) return;

          this.folders.push({
            id: Date.now().toString(),
            name: this.newFolderName,
            ambientesIds: []
          });
          this.newFolderName = '';
          this.saveFileSystem();
          this.$bvModal.hide('modal-create-folder');
        },

        //aggiorna il backend
        async saveFileSystem() {
          console.log("salva configurazione su backend: ", this.folders);
          this.$store.dispatch("aggiornaMapsAndFolders", {
              plantId: this.plantDetails.id,
              section: this.section,
              //maps: (this.openedFolderId != null) ? this.plantDetails[this.section] : this.visibleAmbientes,
              maps: this.plantDetails[this.section],
              folders: this.folders
          });
        },
        picReady(id) {
            //console.log("picReady " + id, this.picLoaded);
            Vue.set(this.picLoaded,'pic'+id,id);
            //this.$forceUpdate();
        },
        //elimina una mappa
        deleteAmbient(ambId) {
          this.$bvModal.msgBoxConfirm(this.$t("planimetry.confirm_delete"), {
              title: this.$t("attention") + '!',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: this.$t("settings.delete"),
              cancelTitle: this.$t("cancel"),
              footerClass: 'p-2',
              hideHeaderClose: true,
              centered: true
          })
          .then(value => {
              if (value) {
                this.$store.dispatch('deleteMapAndSync', {
                  section: this.section,
                  ambId: ambId,
                  plantId: this.plantDetails.id
                });
              }
          });
        },
        //riporta una mappa in home
        takebackHome(mapId) {
          //riporto la mappa in root
          this.folders.find(f => f.id === 'root').ambientesIds.push(mapId);
          this.currentlyVisibleCardIds.splice(this.currentlyVisibleCardIds.indexOf(mapId),1);
          console.log("situazione folder: ", this.folders);
          this.saveFileSystem();
        },

        chiudiNoSave()
        {
            this.$bvModal.hide('modal-ambiente');
        },
        //-------------------------------------------------------------
        // Funzione che effettua il salvataggio delle modifiche
        //-------------------------------------------------------------
        salvaDettaglioMappa(ev) {
            console.log("chiuso dettaglio mappa", ev);

            //const self = this;
            if (this.currentAmbiente == null) return;
            if (this.currentAmbiente.name.trim() == '') {
                ev.preventDefault();
                this.$bvModal.msgBoxConfirm(this.$t('scenario.warning_zone'), {
                    title: this.$t('scenario.warning'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OK',
                    cancelTitle: this.$t('scenario.close').toUpperCase(),
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    // if (!value) {
                    //     //chiudo la modale ed elimino l'ambiente aggiunto
                    //     self.$store.state.currentPlant[self.section].pop();
                    //     self.currentAmbiente = null;
                    //     self.$bvModal.hide('modal-ambiente');
                    //     self.$forceUpdate();
                    // }
                })
                return;
            }
            //salvo le modifiche
            console.log("nuova planimetria: ",this.currentAmbiente);
            this.handleModalSave(this.currentAmbiente);

            var mappe = this.plantDetails[this.section];
            // console.log("mappe:", mappe);
            // mappe.forEach(function(m) {
            //     m.isNew = false;
            // });

            this.currentAmbiente.isNew = false;

            const indexMap = mappe.findIndex(m => m.id === this.currentAmbiente.id);
            const mappa = this.plantDetails[this.section][indexMap];

            //invia aggiornamento al backend
            //this.$store.dispatch("aggiornaMappePost",{plantId: this.plantDetails.id, mapType: this.section, maps: mappe});
            console.log("salva singola mappa", this.currentAmbiente);
            const cmdData = {
                plantId: this.plantDetails.id,
                mapType: this.section,
                map: mappa,
                index: indexMap
            };
            console.log("cmdData:", cmdData);
            this.$store.dispatch("aggiornaSingolaMappaPost",cmdData);
            this.isDirty = false; //ho salvato le modifiche

            // Reset lamp positions before closing

            //this.resetZoomToZero();
            //self.$bvModal.hide('modal-ambiente');
        },


        //--------------------------------------------------------------------------------
        // Funzione chiamata alla chiusura del dettaglio mappa tramite bottone X
        // prevede richiesta conferma della chiusura senza il salvataggio delle modifiche
        //--------------------------------------------------------------------------------
        chiudiDettaglioMappa() {
            const self = this;
            if (this.isDirty) {
                this.$bvModal.msgBoxConfirm(this.$t('scenario.close_not_saved'), {
                    title: this.$t('scenario.warning'),
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    okTitle: 'OK',
                    cancelTitle: this.$t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        // Reset lamp positions before closing
                        this.resetZoomToZero();
                        //chiudo la modale
                        self.$bvModal.hide('modal-ambiente');
                    }
                })
            } else {
                //Se non è stato caricato nulla, devo cancellare l'ultimo elemento inserito nella lista altrimenti resta presente una card vuota
                let mappe = this.plantDetails[this.section];
                console.log("stato piante ", mappe);
                if (!this.imgUploaded && mappe[mappe.length-1].isNew) {
                    console.log("Elimino pianta vuota");
                    mappe.pop();
                    this.showDropZone = false;
                }
                // Reset lamp positions before closing
                this.resetZoomToZero();
                self.$bvModal.hide('modal-ambiente');
            }
        },

        stateDesc: function(value) {
            if (this.hasError(value))
                return this.$t('planimetry.lamp_error');
            return this.$t('planimetry.lamp_ok');
        },
        hasError: function(lampDet) {
            if(lampDet.error_batt_short == 'ON'
            || lampDet.error_hardware == 'ON'
            || lampDet.error_batt_test == 'ON'
            || lampDet.error_com_radio_lamp == 'ON'
            || lampDet.error_led == 'ON'
            || lampDet.error_tubo_UV == 'ON'
            || lampDet.error_overpower == 'ON'
            || lampDet.error_underpower == 'ON'
            || lampDet.error_overvoltage == 'ON'
            || lampDet.error_undervoltage == 'ON'
            || lampDet.errorBallastCom == 'ON'
            || lampDet.lampFail == 'ON'
            || lampDet.error_com_ak_lamp == 'ON'
            || lampDet.error_id_duplicate == 'ON'
            || lampDet.error_lamp_programming == 'ON'
            || lampDet.error_led_full_short == 'ON'
            || lampDet.error_led_open =='ON'
            || lampDet.error_led_partial_short == 'ON'
            || lampDet.error_polarity_reverse == 'ON'
            || lampDet.error_under_threshold == 'ON'
            )
                return true;
            else
                return false;
        },
        hasErrorCom: function(lampDet) {
            if(lampDet.error_com == 'ON')
                return true;
            else
                return false;
        },
        hasOrphan: function(lampDet) {
            if(lampDet.nodo_orfano==true)
                return true;
            else
                return false;
        },
        isInEmergency: function(lampDet) {
            if(lampDet.emer_active == 'EMERGENZA IN CORSO')
                return true;
            else
                return false;
        },
        tipoLamp: function(lamp) {
            if(lamp.device_function=="EMERGENZA" || lamp.device_function=="ILLUMINAZIONE" || lamp.device_function=="ALTRO" || lamp.device_function=="CU")
                return (lamp.device_function ).toLowerCase();
            else
                return ("emergenza");
        },
        showModalRimuoviLampada(lamp) {
            this.lampToRemove=lamp;
            //this.$refs['modalRemoveLamp'].show();
            this.$bvModal.show('modal-remove-lamp');
        },
        removeLamp(lamp) {
          if (!lamp) return;
          this.selectedLamp=null;
          this.currentAmbiente.lamps = this.currentAmbiente.lamps.filter(item => item.id !== lamp.id);
        },
        dragLamp(lamp,index,ev) {
            console.log("dragStart",lamp,index,ev,this.tipoLamp(lamp));
            this.draggedLamp = lamp;
            console.log("dragged Lamp in drag",this.draggedLamp);
            var tipo = this.tipoLamp(lamp);
            var img = document.createElement("img");
            img.src = '/img/dot_drag_' + tipo.toLowerCase() + '.png';
            img.style.width = "32px";
            img.style.height = "32px";
            ev.dataTransfer.setDragImage(img,16,16);
        },
        highlightLamp(lamp,index) {
            console.log("highlight",lamp,index,this.currentAmbiente.lamps)
            if (lamp.alreadyAdded) {
                var selLamp = this.currentAmbiente.lamps.filter(function(l) {
                    return l.id == lamp.id;
                })
                if (selLamp != null) {
                    this.selLampDot(selLamp[0],-1);
                }
            }
        },
        dropLamp(lamp,index,ev) {
            ev.preventDefault();
            console.log("drop!", ev, lamp);


            if (this.draggedLamp != null) {
                this.markAsDirty();
                const w = ev.target.offsetWidth;
                const h = ev.target.offsetHeight;
                const px = ev.offsetX * 100 / w;
                const py = ev.offsetY * 100 / h;

                var status_dragged="";
                var tipo = this.tipoLamp(this.draggedLamp);

                console.log("dragged Lamp in drop", this.draggedLamp, tipo);

                if (tipo == "cu") {
                    status_dragged="ok";
                }
                else {
                  if (this.draggedLamp.nodo_orfano==true) {
                    status_dragged="orphan";
                  } else {
                    // 1. get all keys from the object
                    // 2. filter keys that start with "error_"
                    // 3. check if at least one of those keys has the value 'ON'
                    const hasAnyError = Object.keys(this.draggedLamp)
                        .filter(key => key.startsWith('error_'))
                        .some(key => this.draggedLamp[key] === 'ON');
                    status_dragged = hasAnyError ? "err" : "ok";
                  }
                }

                console.log("dragged lamp: ", this.draggedLamp.id, status_dragged, px, py,tipo);

                this.currentAmbiente.lamps.push(
                    {
                        id: this.draggedLamp.id,
                        status: status_dragged,
                        px: px,
                        py: py,
                        selected: false,
                        tipo: tipo
                    }
                )

                console.log("dragged ambient: ", this.currentAmbiente);

                this.draggedLamp = null;
            }

        },
        bigImgLoaded() {
            const elem = document.getElementById("imgBig");
            if (elem == null) return;
            console.log("image loaded " + elem.src);

            //rimuovi filtri lampade non assegnate nei tab 0 e 1 (da usare solo nel tab 2)
            console.log("tabIndex",this.tabIndex);
            if(this.tabIndex!=2)
            {
                this.filtroLampadeLibere=false;
                this.filtro="";
            }

            if (elem.src.indexOf('empty_map') > 0) return;
            this.imgLoaded = true;
        },
        closeDropZone() {
            this.showDropZone = false;
            this.$refs.myVueDropzone.removeAllFiles();
        },
        uploadImg() {
            console.log("upload img")
            this.showDropZone = true
        },
        imageUrl(ambid) {
            if (this.currentAmbiente != null && this.currentAmbiente.id == ambid) {
                //console.log("imageUrl, isNew=" + this.currentAmbiente.isNew + "," + this.imgUploaded + ", path=" + this.pathMapImages + "img/" + this.section +"/" + this.plantId + '-' + ambid + '.jpg');
                if (this.currentAmbiente.isNew && !this.imgUploaded) {
                    return "/img/empty_map.jpg";
                }
            }
            return this.pathMapImages + "img/" + this.section +"/" + this.plantId + '-' + ambid + '.jpg';
        },
        sendingImage(file,xhr,formData) {
            console.log("sendingImage",file,xhr,formData);
            console.log(file.type, file.dataURL);
            const buf = Buffer.from(file);
            console.log(buf.toString('base64'));
            //xhr.setRequestHeader("Content-Type","application/json")
        },
        fileAdded(file) {
            console.log("file added",file);
            const self = this;
            const reader = new FileReader();
            reader.onloadend = function(result) {
                //self.markAsDirty();
                console.log("result:",result);
                self.axios.post('', {
                    action: 'uploadImage',
                    plantId: self.plantDetails.id,
                    type: self.section,
                    resId: self.currentAmbiente.id,
                    data: result.target.result
                })
                .then(function (response) {
                    console.log("post eseguita",response);
                    self.$nextTick(() => {
                        self.showDropZone = false;
                        self.$refs.myVueDropzone.removeAllFiles();
                        self.imgUploaded = true;
                        self.$forceUpdate();
                    });
                })
                .catch(function (error) {
                    console.log("errore post",error);
                });
            }
            reader.readAsDataURL(file);

        },
        //gestisce l'evento mousedown
        mdown(obj,index, ev) {
            console.log("mdown",obj, ev)
            if (obj != null) {
                this.selLampDot(obj,-1);
                if (this.tabIndex != 2) return;

                // Pause panZoom
                if (this.$refs.zoomContainer) {
                  this.$refs.zoomContainer.$panZoomInstance.pause();
                }
                // Use of getBoundingClientRect for more stability than offset
                const rect = ev.target.getBoundingClientRect();
                const parentRect = ev.target.parentElement.getBoundingClientRect();

                //get current zoom scale
                const scale = this.$refs.zoomContainer.$panZoomInstance.getTransform().scale;

                this.drgX = (rect.left - parentRect.left) / scale;
                this.drgY = (rect.top - parentRect.top) / scale;

                this.dragStartEv = ev;
                this.dragging = true;

                // Prevent browser ghosting
                ev.preventDefault();
            }
        },
        //gestisce l'evento mousemove
        mmove(ev) {
            if (!this.dragging) return
            ev.preventDefault();
            let draggedEl = document.getElementById("dragged")
            if (draggedEl != null) {
              //get the current zoom scale
              let scale = this.$refs.zoomContainer.$panZoomInstance.getTransform().scale;

              draggedEl.style.visibility = 'visible';

              // logica: StartPosition + (MouseMovement / ZoomScale)
              const moveX = (ev.clientX - this.dragStartEv.clientX) / scale;
              const moveY = (ev.clientY - this.dragStartEv.clientY) / scale;

              draggedEl.style.left = (this.drgX + moveX) + 'px';
              draggedEl.style.top = (this.drgY + moveY) + 'px';
            }
        },
        //gestisce l'evento mouseup
        mup(ev) {
            //console.log("mup",ev)
            if (this.dragging && this.dragStartEv != null) {
                this.markAsDirty();
                let elem = document.getElementById("imgBig");

                // We use getBoundingClientRect() becuase it takes in account any
                // padding, margins of CSS shifts
                const rect = elem.getBoundingClientRect();

                let scale = 1.0

                var zoomC = this.$refs.zoomContainer;

                if (zoomC != null) {
                    var panZoomObj = zoomC.$panZoomInstance;
                    scale = panZoomObj.getTransform().scale;
                }

                // Calculate actual image width/height at scale x.y
                const w = rect.width / scale;
                const h = rect.height / scale;

                let draggedEl = document.getElementById("dragged");
                draggedEl.style.visibility = "hidden";
                // dx and dy calculate the % movement relative to the large image size
                let dx = (ev.clientX - this.dragStartEv.clientX) * 100 / w / scale;
                let dy = (ev.clientY - this.dragStartEv.clientY) * 100 / h / scale;

                console.log("dx=" + dx + ", dy=" + dy);
                let obj = this.selectedLamp;
                // Apply boundaries (0-100%)
                var newX = Math.min(100,Math.max(0,obj.px + dx));
                var newY = Math.min(100,Math.max(0,obj.py + dy));
                obj.px = newX;
                obj.py = newY;
            }

            //resume panZoom regardless of whether the drag was successful
            if (this.$refs.zoomContainer) {
              this.$refs.zoomContainer.$panZoomInstance.resume();
            }
            this.dragging = false
            this.dragStartEv = null;
        },
        selLampDot(obj, index, ev) {
          // 1. handle selection logic:
          if (ev && (ev.ctrlKey || ev.metaKey)) {
            //multi-select mode: toggle current lamp's state
            obj.selected = !obj.selected;
          } else {
            //single-select mode: deselect all others, select current
            this.currentAmbiente.lamps.forEach(l => l.selected = false);
            obj.selected = true;
          }
          // 2. mantain 'selectedLamp' for existing single-select logic/details panel
          this.selectedLamp = obj;
          // 3. keep existing scrolling logic:
          // se è selezionato il tab 2, 'Move and modify', si seleziona l'elemento 'lamprow-xyzj' altrimenti
          // si seleziona il 'lrow-xyzj' di tab 1, anche se fosse visibile tab 0
          this.$nextTick(() => {
            let elem = null;
            const prefix = this.tabIndex === 2 ? 'lamprow-' : 'lrow-';
            elem = document.getElementById(prefix + obj.id);
            if (elem) {
              elem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });

            // console.log("sel lamp dot:" + index, obj);
            // if (this.selectedLamp != null) {
            //     this.selectedLamp.selected = false;
            // }
            // obj.selected = true;
            // this.selectedLamp = obj

            // var elem = null;
            // if (this.tabIndex == 2) {
            //     elem = document.getElementById('lamprow-' + obj.id);
            //     if(elem !=null)
            //     {
            //      elem.scrollIntoView();
            //     }
            // } else if (this.tabIndex == 1) {
            //     elem = document.getElementById('lrow-' + obj.id);
            //     elem.scrollIntoView();
            // }

        },
        lampInfo(ambientIndex,lampIndex) {
            let lampInfo = this.ambienti[ambientIndex].lamps[lampIndex];
            return lampInfo;
        },

        handleResize() {
            this.$forceUpdate();
        },
        // //----------------------------------------------------------------------------------------
        // // Funzione che apre la modale di dettaglio ambiente, passando una deep copy dell'oggetto
        // //----------------------------------------------------------------------------------------
        // apriModal(index) {
        //     console.log("apro modal " + index);
        //     console.log("lamps on maps " + this.lampsOnMaps);
        //     this.tipiLampade="";
        //     this.filtro="";
        //     this.isDirty = false;

        //     if (this.$store.getters.isProExpired) return;
        //     //creo la deep copy dell'ambiente
        //     this.currentAmbiente = JSON.parse(JSON.stringify(this.ambienti[index]));
        //     console.log("deep copy",this.currentAmbiente);
        //     //this.currentAmbiente = this.ambienti[index];

        //     let self = this;
        //     this.imgLoaded = false;
        //     this.showMinimap = false;
        //     window.setTimeout(function() {
        //         self.$bvModal.show('modal-ambiente');
        //         //self.$forceUpdate();
        //     }, 100);
        // },
        apriModalById(id) {
          console.log("apro modal per ID: " + id);
          console.log("ambienti presenti: ", this.ambienti);

          // 1. Basic check
          if (this.$store.getters.isProExpired) return;

          // 2. Find the object in the computed list
          const targetAmbiente = this.ambienti.find(a => a.id === id);

          if (!targetAmbiente) {
            console.error("Ambiente with ID " + id + " not found");
            return;
          }

          // 3. Reset UI state
          this.tipiLampade = "";
          this.filtro = "";
          this.isDirty = false;
          this.imgLoaded = false;
          this.showMinimap = false;

          // 4. Create the deep copy
          this.currentAmbiente = JSON.parse(JSON.stringify(targetAmbiente));

          // 5. Show modal
          let self = this;
          window.setTimeout(function() {
            self.$bvModal.show('modal-ambiente');
          }, 100);
        },
        //----------------------------------------------------------------------------------------------
        // Funzione che salva in store.js le modifiche apportate all'ambiente, in modo che poi, tramite
        // la reaction di Vuex, vengano aggiornate anche le variabili locali di AmbientiPlanimetrie.vue
        //----------------------------------------------------------------------------------------------
        handleModalSave(modifiedAmbiente) {
            // Find the index of the original object
            const index = this.plantDetails[this.section].findIndex(a => a.id === modifiedAmbiente.id);
            if (index === -1) {
                console.error("Ambiente non trovato nell'array");
                return;
            }
            // Creiamo una nuova versione dell'array della sezione specifica
            const newSectionArray = [...this.plantDetails[this.section]];
            // Sostituiamo l'oggetto all'indice trovato con 'modifiedAmbiente'
            newSectionArray[index] = modifiedAmbiente;
            // Costruiamo il nuovo oggetto plantDetails partendo dall'originale e cambiando solo 'section'
            const plantModified = {
                ...this.plantDetails,
                [this.section]: newSectionArray
            };
            console.log("plantModified: ", plantModified);
            this.$store.commit('setPlantDetails', plantModified);
        }
    },
    directives: {
      focus: {
        inserted(el) {
          el.focus();
        }
      }
    }

}

</script>

<style lang="scss">

  span.draggable-placeholder {
    display: inline-flex;
  }

  .sortable-ghost {
    opacity: 0.5;
  }

  #imgDivBig {
    position: relative;
    width: 100%;
    height: auto; //consente al container, cioè imgDivBig, di essere alto come l'immagine al suo interno
    min-height: 400px;
    max-height: 80vh; //impedisce all'immagine di essere più grande dello schermo
    background-color: #eee;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 2px solid black;
  }
  #imgBig { //property che consentono all'immagine di adattarsi perfettamente al suo container
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }

  /* Container padding and background */
  .filesystem-containers {
    padding: 20px;
    min-height: 400px;
    z-index: 1;
  }

  /* folder wrapper: the 'hit area' for double clicking and dragging */
  .breadcrumb-nav-container {
    //flex-grow: 1; /*allow the breadcrumb area to fill the remaining space */
    padding-bottom: 10px;
    padding-right: 50px;
  }

  .filesystem-containers .breadcrumb {
    display: flex !important;
    position: static !important;
    top: auto !important;
    left: auto !important;
    margin-bottom: 0 !important;
    padding: 1 !important;
    background-color: transparent !important;
    float: none !important;
    width: auto !important;
  }

  .filesystem-containers .breadcrumb-item {
    display: flex !important;
    align-items: center !important;
  }


  .filesystem-containers .breadcrumb-item a {
    color: #007bff;
    align-items: none;
  }

  .folder-wrapper {
    cursor: pointer;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 180px;
  }

  .folder-wrapper:hover {
    background-color: rgba(0, 123, 255, 0.08);
    border: 1px solid #007bff44;
  }
  //nasconde il ghost durante un drag
  .hide-ghost {
    opacity: 0 !important;
    height: 0 !important;
    width: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden !important;
  }

  /* Normal state: hide the special drag content */
  .drag-content-only {
    display: none;
  }
  .custom-card-header {
    font-size: 0.875rem;
    min-height: 40px;
  }

  /* DRAG STATE: when this card is being dragged (triggered by vuedraggable fallback*/
  .mini-drag-icon {
    /* meke the container invisible */
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    width: auto !important;
    height: auto !important;
    pointer-events: none !important;
  }
  /* hide the main card only when dragging */
  .mini-drag-icon .card-main-content {
    display: none !important;
  }
  /* Show the special icon only when dragging */
  .mini-drag-icon .drag-content-only {
    display: block !important;
    color: #a1c3e7;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
    font-size: 30px;
  }

  //definisce meglio la zona di drop nel breadcrumb
  .home-drop-zone {
    padding: 4px 10px !important;
    margin-left: -5px;
    transition: all 0.2s;
    cursor: pointer;
  }

  body.sortable-drag .home-drop-zone {
    background-color: rgba(0, 123, 255, 0.05);
    border-radius: 4px;
  }
  .home-drop-zone.sortable-ghost,
  .home-drop-zone:hover {
    background-color: #e3f2fd !important;
    color: white !important;
    transition: background-color 0.2s ease;
  }

  .home-drop-zone.sortable-ghost a {
    color: white !important;
  }

  .home-drop-zone .hide-ghost {
    display: none !important;
  }

  /* The visual icon container */
  .folder-visual {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    height: 100px; // fixed height for the 'Large Icon' area
  }

  .folder-icon-container {
    position: relative;
    display: inline-block;
    transform: scale(1.4);
    transition: transform 0.2s ease;
  }
  /* Folder Icon Color adjustments */
  .folder-visual i.fa-folder {
    color: #ffca28; // Classic Windows Folder Yellow
    filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.1));
  }

  /* Item Count Badge */
  .item-count {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -10%); //positioned inside the folder 'pocket'
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 2px 8px;
    border-radius: 10px;
    pointer-events: none;
  }

  /* Ensure the text label stays clean */
  .folder-wrapper p {
    margin: 0;
    font-weight: 500;
    color: #333;
    word-break: break-all;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  /* Dragging Ghost class (what the card looks like while moving) */
  .ghost-card {
    opacity: 0.4;
    background: #c8ebfb;
    border: 2px dashed #007bff;
  }

  /* Dropzone highlight (when hovering over a folder while dragging) */
  .folder-wrapper.sortable-chosen {
    background-color: rgba(40, 167, 69, 0.1) !important;
  }

  .square-dropdown {
    position: fixed;
    bottom: 40px;
    left: 30px;
    z-index: 1000;
  }

  .square-dropdown-toggle {
    width: 100px !important;
    height: 100px !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    //border-radius: 50% !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
    transition: transform 0.2s;
  }

  .square-dropdown-toggle:hover {
    transform: scale(1.05);
  }
  .square-dropdown .dropdown-menu {
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    border: none;
    padding: 10px 0;
  }

  .square-dropdown-toggle .plus {
    font-size: 30px;
    font-weight: bold;
  }

  .square-dropdown-toggle .label {
    // margin-top: 6px;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }

  /* Prevent bootstrap's auto sizing */
  .square-dropdown .dropdown-toggle::after {
    display: none;
  }

  @media (max-width: 768px) {
    .square-dropdown {
      display: flex;
      bottom: 70px;
      left: 10px;
    }
    .square-dropdown-toggle {
      width: 60px !important;
      height: 60px !important;
      /* use flexbox for perfect centering */
      display: flex !important;
      flex-direction: column; //stack vertically
      justify-content: center; //center vertically
      align-items: center; //center horizontally
      padding: 0 !important;
      //border-radius: 50% !important; //makes it a perfect circle
    }
    .square-dropdown-toggle .plus {
      font-size: 32px;
      margin: 0;
      line-height: 0.8;
      position: relative;
      top: -2px; //corregge il carattere '+' che non è perfettamente centrato nel suo font box, restando più in basso
    }
    .square-dropdown-toggle .label {
      font-size: 12px;
    }
  }

  .btn-action-vibrant {
    background-color: white !important;
    color: black !important;
    //border: 1px solid black !important;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    z-index: 500;
    transition: background-color 0.2s ease; //smooth color transition
  }
  .btn-action-vibrant:hover,
  .btn-action-vibrant:focus,
  .btn-action-vibrant:active {
    background-color: #e0e0e0 !important;
    color: black !important;
    //border-color: black !important;
    box-shadow: 0 6px 12px rgba(0,0,0,0.2)  !important;
  }
  .square-dropdown-toggle.custom-fab {
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  }

  /* Position the Minimap */
  .minimap-container {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 150px;
      height: auto;
      border: 1px solid #fff;
      //background: rgba(0,0,0,0.5);
      background: rgba(247, 245, 245, 0.5);
      z-index: 5;
      pointer-events: none; /* Let clicks pass through to the panzoom */
  }

  .minimap-bg {
      width: 100%;
      display: block;
      opacity: 0.6;
  }

  .minimap-viewfinder {
      position: absolute;
      border: 1px solid red;
      background: rgba(255, 0, 0, 0.2);
      top: 0; left: 0;
  }
  .minimap-dot {
      position: absolute;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      transform: translate(-50%, -50%) /* Center the dot on the coordinate */
  }
  /* Colors based on your lamp status logic */
  .status-ok { background-color: #28a745; } /* OK - Green */
  .status-errcom { background-color: #FFFF00; } /* ErrorCom - Yellow */
  .status-err { background-color: #dc3545; } /* Error - Red */
  .status-offline { background-color: #6c757d; } /* Grey */
  .status-orphan { background-color: rgb(238, 130, 238); } /* Warning - Yellow */

  .btn-minimap-floating {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 10;
      background-color: rgba(255, 255, 255, 0.8);
      color: #333;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 12px;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.2s ease;
  }
  .btn-minimap-floating:hover {
      background-color: #f8f9fa;
      border-color: #bbb;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }


  .btn-reset-floating {
      position: absolute;
      top: 50px;
      right: 15px;
      z-index: 10;
      background-color: rgba(255, 255, 255, 0.8);
      color: #333;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 12px;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      //transition: all 0.2s ease;
  }
  .btn-reset-floating:hover {
      background-color: #f8f9fa;
      border-color: #bbb;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  /*animazione di entrata/uscita*/
  .fade-enter-active, .fade-leave-active {
      transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to {
      opacity: 0;
  }

  .modal-fullscreen .modal-dialog {
      max-width: 100%;
      margin: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100vh;
      z-index: 100000;
  }

  .nopad {
        padding: 0;
      }

  .imgDiv {
      position: relative;
      display: inline-block; /* Crucial: wrapper shrinks to the image size */
      width: 100%;           /* Allows it to fit the b-col */
      overflow: hidden;
  }

  .dotImg {
      width: 8px;  /* Set a fixed size for small cards */
      height: 8px;
      z-index: 10;
      pointer-events: none; /* Prevents the icon from blocking clicks on the map */
  }


  @keyframes highlightedDotAnim {
      0% {background-color: rgba(255,255,255,0);}
      50% {background-color: rgba(255,255,0,0.8);}
      100% {background-color: rgba(255,255,255,0);}
  }

  .dotImgHighlight {
      background-color: #ffff00;
      width: 61px;
      height: 61px;
      padding: 24px;
      border-radius: 32px;
      animation: highlightedDotAnim 1s ease-in-out infinite;
  }

  // per accessibilità: il browser espone questa preferenza, 'prefers-reduced-motion', per evitare il flashing che può causare problemi
  // a persone con particolare patologie
  @media (prefers-reduced-motion: reduce) {
    .dotImgHighlight {
      animation: none;
      transition: none;
    }
  }

  .dotImgEmergency {
      background-color: orange;
      width:  15px;
      height: 15px;
      padding: 3px;
      border-radius: 32px;
  }

  .dotImgBigEmergency {
      background-image: radial-gradient(orange,transparent) !important;
      padding: 15px !important;
      border-radius: 32px !important;
  }


  .dotImgBig {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      float: left;
      // width: 50px;
      // height: 50px;
      // padding: 16px;
      width: 40px;
      height: 40px;
      padding: 12px;
      background-color: #ffffff11;
      border-radius: 12px;
      z-index: 10000;

      /* apply the dynamic scale that depends on the zoom */
      transform: translate(-50%, -50%) scale(var(--icon-scale, 1)) !important;

      transition: transform 0.1s ease-out;
  }

  .dotSel {
      background-color: #00990044;
  }

  .modal-xl {
      max-width: 95%;
  }
  .uploadButton {
      position: absolute;
      left: 0;
      bottom: 0;
  }

  .infoTip {
      position: absolute;
      right: 5px;
      bottom: 5px;
  }

  .closeButton {
      position: absolute;
      right: 0;
      top: 0;
  }

  #dropzoneContainer {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #eeeeee;
      top: 0;
      margin-top: auto;
      margin-bottom: auto;
      padding: 16px;
      z-index: 11000;
  }
  #dropzone {
      height: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      border: 2px dashed #007bff;
  }
  .draggableRow {
      cursor: pointer;
  }
  .lampUsed {
      background-color: #ffff;
  }

  .highlightedRow {
      background-color: #b3d3ec;
  }

  .highlightedAdded {
      background-color: #ffff;
  }
  .green {
      color: #009900;
  }
  .error {
      color: #cc0000;
  }

  #modal-ambiente .modal-content {
      min-height: 600px;
  }
  .icon-gap {
    margin-right: 0.3rem;
  }

  .text-folder-blue {
    color: #3498db !important;
  }
  .text-folder-blue:hover {
    color: #2980b9 !important;
  }
  /* Ensure buttons don't trigger a drag by accident */
  .card-header-actions a {
    cursor: pointer;
    position: relative;
    z-index: 10;
  }
  .card-header-actions i {
    transition: transform 0.2s ease, color 0.2s ease;
  }
  .card-header-actions i:hover {
    transform: scale(1.2); /* makes the icon grow slightly when hovered */
  }
  .text-trash-black {
    color: #73818f
  }
  .text-trash-black:hover {
    color: #25282c
  }
  /* hide the button by default */
  .show-on-hover {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  /* show the button when the card is hovered*/
  .folder-wrapper:hover .show-on-hover {
    opacity: 1;
  }
  /* prevent text selection on cards and folders to keep the drag clean */
  .card-main-content,
  .folder-name-container p,
  .custom-card-header {
    user-select: none;
    -webkit-user-select: none; /*safari*/
    -ms-user-select: none; /*IE10+*/
    -moz-user-select: none; /*firefox*/
  }
  /* ensure the input still allows selection so the user can type/edit names */
  .folder-name-container input {
    user-select: text !important;
    -webkit-user-select: text !important;
    -ms-user-select: text !important; /*IE10+*/
    -moz-user-select: text !important; /*firefox*/
  }
  .no-drag {
    cursor: text !important;
  }

  .custom-add-btn {
    background-color: white !important;
    color: black !important;
    //border: 1px solid #000 !important;
    border-radius: 10px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
  }

  .custom-add-btn:hover,
  .custom-add-btn:focus {
    background-color: #f0f0f0 !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.16);
    transform: translateY(-1px);
  }

  .custom-add-btn:active {
    background-color:#e0e0e0 !important;
    transform: translateY(0);
  }

  .custom-add-btn i {
    font-size: 1rem;
  }

  .custom-dropdown-menu {
    z-index: 490 !important;
  }
</style>
